(window.theme = window.theme || {}),
    (window.slate = window.slate || {}),
    (window.lazySizesConfig = window.lazySizesConfig || {}),
    (lazySizesConfig.expFactor = 4),
    (function (e) {
        var e = (jQuery = e);
        (slate.utils = {
            defaultTo: function (e, t) {
                return null == e || e != e ? t : e;
            },
        }),
            (slate.a11y = {
                trapFocus: function (t) {
                    var i = t.namespace ? "focusin." + t.namespace : "focusin";
                    t.$elementToFocus || (t.$elementToFocus = t.$container),
                        t.$container.attr("tabindex", "-1"),
                        t.$elementToFocus.focus(),
                        e(document).off("focusin"),
                        e(document).on(i, function (e) {
                            t.$container[0] === e.target || t.$container.has(e.target).length || t.$container.focus();
                        });
                },
                removeTrapFocus: function (t) {
                    var i = t.namespace ? "focusin." + t.namespace : "focusin";
                    t.$container && t.$container.length && t.$container.removeAttr("tabindex"), e(document).off(i);
                },
                lockMobileScrolling: function (t, i) {
                    if (i) var n = i;
                    else var n = e(document.documentElement).add("body");
                    n.on("touchmove" + t, function () {
                        return !1;
                    });
                },
                unlockMobileScrolling: function (t, i) {
                    if (i) var n = i;
                    else var n = e(document.documentElement).add("body");
                    n.off(t);
                },
            }),
            (theme.Sections = function t() {
                (this.constructors = {}),
                    (this.instances = []),
                    e(document)
                        .on("shopify:section:load", this._onSectionLoad.bind(this))
                        .on("shopify:section:unload", this._onSectionUnload.bind(this))
                        .on("shopify:section:select", this._onSelect.bind(this))
                        .on("shopify:section:deselect", this._onDeselect.bind(this))
                        .on("shopify:block:select", this._onBlockSelect.bind(this))
                        .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
            }),
            (theme.Sections.prototype = e.extend({}, theme.Sections.prototype, {
                createInstance: function (t, i, n) {
                    var a = e(t),
                        o = a.attr("data-section-id"),
                        s = a.attr("data-section-type");
                    if (void 0 !== (i = i || this.constructors[s])) {
                        if (n && this._findInstance(o)) return;
                        var r = e.extend(new i(t), { id: o, type: s, container: t });
                        this.instances.push(r);
                    }
                },
                _onSectionLoad: function (t, i, n) {
                    AOS && AOS.refreshHard();
                    var a = i || e("[data-section-id]", t.target)[0];
                    if (a) {
                        this.createInstance(a);
                        var o = i ? n : this._findInstance(t.detail.sectionId);
                        i || this._loadSubSections(), o && "function" == typeof o.onLoad && o.onLoad(t);
                    }
                },
                _loadSubSections: function () {
                    AOS && AOS.refreshHard(),
                        e("[data-subsection]").each(
                            function (t, i) {
                                this._onSectionLoad(null, i, e(i).data("section-id"));
                            }.bind(this)
                        );
                },
                _onSectionUnload: function (e) {
                    var t = this._removeInstance(e.detail.sectionId);
                    t && "function" == typeof t.onUnload && t.onUnload(e);
                },
                _onSelect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    t && "function" == typeof t.onSelect && t.onSelect(e);
                },
                _onDeselect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    t && "function" == typeof t.onDeselect && t.onDeselect(e);
                },
                _onBlockSelect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
                },
                _onBlockDeselect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    t && "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
                },
                _findInstance: function (e) {
                    for (var t = 0; t < this.instances.length; t++) if (this.instances[t].id === e) return this.instances[t];
                },
                _removeInstance: function (e) {
                    for (var t, i = this.instances.length; i--; )
                        if (this.instances[i].id === e) {
                            (t = this.instances[i]), this.instances.splice(i, 1);
                            break;
                        }
                    return t;
                },
                register: function (t, i, n) {
                    this.constructors[t] = i;
                    var a = e("[data-section-type=" + t + "]");
                    n && (a = e("[data-section-type=" + t + "]", n)),
                        a.each(
                            function (e, t) {
                                this.createInstance(t, i, n);
                            }.bind(this)
                        );
                },
            })),
            (theme.Currency = {
                formatMoney: function e(t, i) {
                    "string" == typeof t && (t = t.replace(".", ""));
                    var n = "",
                        a = /\{\{\s*(\w+)\s*\}\}/,
                        o = i || "$";
                    function s(e, t, i, n) {
                        if (((t = slate.utils.defaultTo(t, 2)), (i = slate.utils.defaultTo(i, ",")), (n = slate.utils.defaultTo(n, ".")), isNaN(e) || null == e)) return 0;
                        var a,
                            o = (e = (e / 100).toFixed(t)).split(".");
                        return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (o[1] ? n + o[1] : "");
                    }
                    switch (o.match(a)[1]) {
                        case "amount":
                            n = s(t, 2);
                            break;
                        case "amount_no_decimals":
                            n = s(t, 0);
                            break;
                        case "amount_with_comma_separator":
                            n = s(t, 2, ".", ",");
                            break;
                        case "amount_no_decimals_with_comma_separator":
                            n = s(t, 0, ".", ",");
                            break;
                        case "amount_no_decimals_with_space_separator":
                            n = s(t, 0, " ");
                    }
                    return o.replace(a, n);
                },
                getBaseUnit: function e(t) {
                    if (t && t.unit_price_measurement && t.unit_price_measurement.reference_value)
                        return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit;
                },
            }),
            (theme.Images = {
                imageSize: function e(t) {
                    if (!t) return "620x";
                    var i = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                    return null !== i ? i[1] : null;
                },
                getSizedImageUrl: function e(t, i) {
                    if (null == i) return t;
                    if ("master" === i) return this.removeProtocol(t);
                    var n = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                    if (null != n) {
                        var a = t.split(n[0]),
                            o = n[0];
                        return this.removeProtocol(a[0] + "_" + i + o);
                    }
                    return null;
                },
                removeProtocol: function e(t) {
                    return t.replace(/http(s)?:/, "");
                },
            }),
            (slate.Variants = (function () {
                function t(t) {
                    (this.$container = t.$container),
                        (this.variants = t.variants),
                        (this.singleOptionSelector = t.singleOptionSelector),
                        (this.originalSelectorId = t.originalSelectorId),
                        (this.enableHistoryState = t.enableHistoryState),
                        (this.currentVariant = this._getVariantFromOptions()),
                        e(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
                }
                return (
                    (t.prototype = e.extend({}, t.prototype, {
                        _getCurrentOptions: function () {
                            var t = e.map(e(this.singleOptionSelector, this.$container), function (t) {
                                var i = e(t),
                                    n = i.attr("type"),
                                    a = {};
                                return "radio" !== n && "checkbox" !== n ? ((a.value = i.val()), (a.index = i.data("index")), a) : !!i[0].checked && ((a.value = i.val()), (a.index = i.data("index")), a);
                            });
                            return this._compact(t);
                        },
                        _getVariantFromOptions: function () {
                            var e = this._getCurrentOptions(),
                                t = this.variants,
                                i = !1;
                            return (
                                t.forEach(function (t) {
                                    var n = !0;
                                    t.options,
                                        e.forEach(function (e) {
                                            n && (n = t[e.index] === e.value);
                                        }),
                                        n && (i = t);
                                }),
                                i || null
                            );
                        },
                        _onSelectChange: function () {
                            var e = this._getVariantFromOptions();
                            this.$container.trigger({ type: "variantChange", variant: e }),
                                e &&
                                    (this._updateMasterSelect(e), this._updateImages(e), this._updatePrice(e), this._updateUnitPrice(e), this._updateSKU(e), (this.currentVariant = e), this.enableHistoryState && this._updateHistoryState(e));
                        },
                        _updateImages: function (e) {
                            var t = e.featured_image || {},
                                i = this.currentVariant.featured_image || {};
                            e.featured_image && t.src !== i.src && this.$container.trigger({ type: "variantImageChange", variant: e });
                        },
                        _updatePrice: function (e) {
                            (e.price !== this.currentVariant.price || e.compare_at_price !== this.currentVariant.compare_at_price) && this.$container.trigger({ type: "variantPriceChange", variant: e });
                        },
                        _updateUnitPrice: function (e) {
                            e.unit_price !== this.currentVariant.unit_price && this.$container.trigger({ type: "variantUnitPriceChange", variant: e });
                        },
                        _updateSKU: function (e) {
                            e.sku !== this.currentVariant.sku && this.$container.trigger({ type: "variantSKUChange", variant: e });
                        },
                        _updateHistoryState: function (e) {
                            if (history.replaceState && e) {
                                var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                                window.history.replaceState({ path: t }, "", t);
                            }
                        },
                        _updateMasterSelect: function (t) {
                            e(this.originalSelectorId, this.$container).val(t.id);
                        },
                        _compact: function (e) {
                            for (var t = -1, i = null == e ? 0 : e.length, n = 0, a = []; ++t < i; ) {
                                var o = e[t];
                                o && (a[n++] = o);
                            }
                            return a;
                        },
                    })),
                    t
                );
            })()),
            (slate.rte = {
                init: function () {
                    slate.rte.wrapTable(), slate.rte.wrapVideo(), slate.rte.imageLinks();
                },
                wrapTable: function () {
                    e(".rte table").wrap('<div class="table-wrapper"></div>');
                },
                wrapVideo: function () {
                    var t = e('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
                        i = t.add("iframe#admin_bar_iframe");
                    t.each(function () {
                        e(this).parents(".video-wrapper").length || e(this).wrap('<div class="video-wrapper"></div>');
                    }),
                        i.each(function () {
                            this.src = this.src;
                        });
                },
                imageLinks: function () {
                    e(".rte a img").parent().addClass("rte__image");
                },
            }),
            (theme.Modals = (function () {
                function t(t, i, n) {
                    if (((this.id = t), (this.$modal = e("#" + t)), !this.$modal.length)) return !1;
                    (this.nodes = { $parent: e("html").add("body"), $modalContent: this.$modal.find(".modal__inner") }),
                        (this.config = e.extend(
                            {
                                close: ".js-modal-close",
                                open: ".js-modal-open-" + i,
                                openClass: "modal--is-active",
                                closingClass: "modal--is-closing",
                                bodyOpenClass: "modal-open",
                                bodyOpenSolidClass: "modal-open--solid",
                                bodyClosingClass: "modal-closing",
                                closeOffContentClick: !0,
                            },
                            n
                        )),
                        (this.modalIsOpen = !1),
                        (this.$focusOnOpen = this.config.focusOnOpen ? e(this.config.focusOnOpen) : this.$modal),
                        (this.isSolid = this.config.solid),
                        this.init();
                }
                return (
                    (t.prototype.init = function () {
                        e(this.config.open).attr("aria-expanded", "false"),
                            e(this.config.open).on("click", this.open.bind(this)),
                            this.$modal.find(this.config.close).on("click", this.close.bind(this)),
                            e("body").on(
                                "drawerOpen",
                                function () {
                                    this.close();
                                }.bind(this)
                            );
                    }),
                    (t.prototype.open = function (t) {
                        var i = !1;
                        !this.modalIsOpen &&
                            (t ? t.preventDefault() : (i = !0),
                            t && t.stopPropagation && (t.stopPropagation(), (this.$activeSource = e(t.currentTarget))),
                            this.modalIsOpen && !i && this.close(),
                            this.$modal.prepareTransition().addClass(this.config.openClass),
                            this.nodes.$parent.addClass(this.config.bodyOpenClass),
                            this.isSolid && this.nodes.$parent.addClass(this.config.bodyOpenSolidClass),
                            (this.modalIsOpen = !0),
                            slate.a11y.trapFocus({ $container: this.$modal, $elementToFocus: this.$focusOnOpen, namespace: "modal_focus" }),
                            this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"),
                            e("body")
                                .trigger("modalOpen")
                                .trigger("modalOpen." + this.id),
                            this.bindEvents());
                    }),
                    (t.prototype.close = function () {
                        if (this.modalIsOpen) {
                            e(document.activeElement).trigger("blur"),
                                this.$modal.prepareTransition().removeClass(this.config.openClass).addClass(this.config.closingClass),
                                this.nodes.$parent.removeClass(this.config.bodyOpenClass),
                                this.nodes.$parent.addClass(this.config.bodyClosingClass);
                            var t = this;
                            window.setTimeout(function () {
                                t.nodes.$parent.removeClass(t.config.bodyClosingClass), t.$modal.removeClass(t.config.closingClass);
                            }, 500),
                                this.isSolid && this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass),
                                (this.modalIsOpen = !1),
                                slate.a11y.removeTrapFocus({ $container: this.$modal, namespace: "modal_focus" }),
                                this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false").focus(),
                                e("body").trigger("modalClose." + this.id),
                                this.unbindEvents();
                        }
                    }),
                    (t.prototype.bindEvents = function () {
                        this.nodes.$parent.on(
                            "keyup.modal",
                            function (e) {
                                27 === e.keyCode && this.close();
                            }.bind(this)
                        ),
                            this.config.closeOffContentClick &&
                                (this.$modal.on("click.modal", this.close.bind(this)),
                                this.nodes.$modalContent.on("click.modal", function (e) {
                                    e.stopImmediatePropagation();
                                }));
                    }),
                    (t.prototype.unbindEvents = function () {
                        this.nodes.$parent.off(".modal"), this.config.closeOffContentClick && (this.$modal.off(".modal"), this.nodes.$modalContent.off(".modal"));
                    }),
                    t
                );
            })()),
            (theme.Drawers = (function () {
                function t(t, i, n) {
                    if (
                        ((this.config = { id: t, close: ".js-drawer-close", open: ".js-drawer-open-" + i, openClass: "js-drawer-open", closingClass: "js-drawer-closing", activeDrawer: "drawer--is-open", namespace: ".drawer-" + i }),
                        (this.$nodes = { parent: e(document.documentElement).add("body"), page: e("#MainContent") }),
                        (this.$drawer = e("#" + t)),
                        !this.$drawer.length)
                    )
                        return !1;
                    (this.isOpen = !1), (this.ignoreScrollLock = n), this.init();
                }
                return (
                    (t.prototype = e.extend({}, t.prototype, {
                        init: function () {
                            var t = e(this.config.open);
                            t.attr("aria-expanded", "false"),
                                t.on("click", this.open.bind(this)),
                                this.$drawer.find(this.config.close).on("click", this.close.bind(this)),
                                e("body").on(
                                    "modalOpen",
                                    function () {
                                        this.close();
                                    }.bind(this)
                                );
                        },
                        open: function (t) {
                            t && t.preventDefault(),
                                !this.isOpen &&
                                    (t && t.stopPropagation && (t.stopPropagation(), (this.$activeSource = e(t.currentTarget))),
                                    this.$drawer.prepareTransition().addClass(this.config.activeDrawer),
                                    this.$nodes.parent.addClass(this.config.openClass),
                                    (this.isOpen = !0),
                                    slate.a11y.trapFocus({ $container: this.$drawer, namespace: "drawer_focus" }),
                                    e("body")
                                        .trigger("drawerOpen")
                                        .trigger("drawerOpen." + this.config.id),
                                    this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"),
                                    this.bindEvents());
                        },
                        close: function () {
                            if (this.isOpen) {
                                e(document.activeElement).trigger("blur"),
                                    this.$drawer.prepareTransition().removeClass(this.config.activeDrawer),
                                    this.$nodes.parent.removeClass(this.config.openClass),
                                    this.$nodes.parent.addClass(this.config.closingClass);
                                var t = this;
                                window.setTimeout(function () {
                                    t.$nodes.parent.removeClass(t.config.closingClass);
                                }, 500),
                                    (this.isOpen = !1),
                                    slate.a11y.removeTrapFocus({ $container: this.$drawer, namespace: "drawer_focus" }),
                                    this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false"),
                                    this.unbindEvents();
                            }
                        },
                        bindEvents: function () {
                            this.ignoreScrollLock || slate.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page),
                                this.$nodes.page.on(
                                    "click" + this.config.namespace,
                                    function (t) {
                                        var i = e(t.target);
                                        if (!this.elementInsideDrawer(i)) return this.close(), !1;
                                    }.bind(this)
                                ),
                                this.$nodes.parent.on(
                                    "keyup" + this.config.namespace,
                                    function (e) {
                                        27 === e.keyCode && this.close();
                                    }.bind(this)
                                );
                        },
                        unbindEvents: function () {
                            this.ignoreScrollLock || slate.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page), this.$nodes.parent.off(this.config.namespace), this.$nodes.page.off(this.config.namespace);
                        },
                        elementInsideDrawer: function (e) {
                            return this.$drawer.find(e).length;
                        },
                    })),
                    t
                );
            })()),
            (theme.cart = {
                getCart: function () {
                    return e.getJSON("/cart.js");
                },
                changeItem: function (e, t) {
                    return this._updateCart({ type: "POST", url: "/cart/change.js", data: "quantity=" + t + "&id=" + e, dataType: "json" });
                },
                addItemFromForm: function (e) {
                    return this._updateCart({ type: "POST", url: "/cart/add.js", data: e, dataType: "json" });
                },
                _updateCart: function (t) {
                    return e.ajax(t).then(
                        function (e) {
                            return e;
                        }.bind(this)
                    );
                },
                updateNote: function (t) {
                    var i = { type: "POST", url: "/cart/update.js", data: "note=" + theme.cart.attributeToString(t), dataType: "json", success: function (e) {}, error: function (e, t) {} };
                    e.ajax(i);
                },
                updateCurrency: function (t) {
                    e.ajax({
                        type: "POST",
                        url: "/cart/update.js",
                        data: "currency=" + t,
                        dataType: "json",
                        success: function (e) {
                            location.reload();
                        },
                        error: function (e, t) {},
                    });
                },
                attributeToString: function (t) {
                    return "string" != typeof t && "undefined" == (t += "") && (t = ""), e.trim(t);
                },
            }),
            e(function () {
                e("body").on("click", ".cart__checkout", function () {
                    e(this).addClass("btn--loading");
                }),
                    e("body").on("change", 'textarea[name="note"]', function () {
                        var t = e(this).val();
                        theme.cart.updateNote(t);
                    }),
                    e("body").on("click", ".cart__checkout--ajax", function (t) {
                        if (!e("#CartAgree").is(":checked")) return alert(theme.strings.cartTermsConfirmation), e(this).removeClass("btn--loading"), !1;
                    }),
                    e("body").on("click", ".cart__checkout--page", function (t) {
                        if (!e("#CartPageAgree").is(":checked")) return alert(theme.strings.cartTermsConfirmation), e(this).removeClass("btn--loading"), !1;
                    });
            }),
            (theme.QtySelector = (function () {
                var t = { input: ".js-qty__num", plus: ".js-qty__adjust--plus", minus: ".js-qty__adjust--minus" };
                function i(i, n) {
                    (this.$wrapper = i), (this.$input = i.find(t.input)), (this.$plus = i.find(t.plus)), (this.$minus = i.find(t.minus)), (this.minValue = this.$input.attr("min") || 1);
                    var a = { namespace: null, key: this.$input.data("id") };
                    (this.options = e.extend(a, n)), this.initEventListeners();
                }
                return (
                    (i.prototype = e.extend({}, i.prototype, {
                        initEventListeners: function () {
                            this.$plus.on(
                                "click",
                                function () {
                                    var e = this.validateQty(this.$input.val());
                                    this.addQty(e);
                                }.bind(this)
                            ),
                                this.$minus.on(
                                    "click",
                                    function () {
                                        var e = this.validateQty(this.$input.val());
                                        this.subtractQty(e);
                                    }.bind(this)
                                ),
                                this.$input.on(
                                    "change",
                                    function () {
                                        var e = this.validateQty(this.$input.val());
                                        this.changeQty(e);
                                    }.bind(this)
                                );
                        },
                        addQty: function (e) {
                            this.changeQty(e + 1);
                        },
                        subtractQty: function (e) {
                            var t = e - 1;
                            t <= this.minValue && (t = this.minValue), this.changeQty(t);
                        },
                        changeQty: function (t) {
                            this.$input.val(t), e("body").trigger("qty" + this.options.namespace, [this.options.key, t]);
                        },
                        validateQty: function (e) {
                            return (parseFloat(e) != parseInt(e) || isNaN(e)) && (e = 1), parseInt(e);
                        },
                    })),
                    i
                );
            })()),
            (theme.CartDrawer = (function () {
                var t = { namespace: ".ajaxcart" },
                    i = { drawer: "#CartDrawer", container: "#CartContainer", template: "#CartTemplate", fixedFooter: ".drawer__footer--fixed", fixedInnerContent: ".drawer__inner--has-fixed-footer", cartBubble: ".cart-link__bubble" };
                function n() {
                    (this.status = { loaded: !1, loading: !1 }), (this.drawer = new theme.Drawers("CartDrawer", "cart"));
                    var t = e(i.template).html();
                    (this.template = Handlebars.compile(t)), theme.cart.getCart().then(this.buildCart.bind(this)), this.initEventListeners();
                }
                return (
                    (n.prototype = e.extend({}, n.prototype, {
                        initEventListeners: function () {
                            e("body").on("updateCart" + t.namespace, this.initQtySelectors.bind(this)),
                                e("body").on("updateCart" + t.namespace, this.sizeFooter.bind(this)),
                                e("body").on("updateCart" + t.namespace, this.updateCartNotification.bind(this)),
                                e("body").on("drawerOpen.CartDrawer", this.sizeFooter.bind(this)),
                                e(window).on("resize" + t.namespace, e.debounce(150, this.sizeFooter.bind(this))),
                                e("body").on(
                                    "added.ajaxProduct",
                                    function () {
                                        theme.cart.getCart().then(
                                            function (e) {
                                                this.buildCart(e, !0);
                                            }.bind(this)
                                        );
                                    }.bind(this)
                                );
                        },
                        buildCart: function (n, a) {
                            if ((this.loading(!0), this.emptyCart(), 0 === n.item_count)) e(i.container).append('<p class="appear-animation appear-delay-3">' + theme.strings.cartEmpty + "</p>");
                            else {
                                var o = [],
                                    s = {},
                                    r = {},
                                    c = 1;
                                e.each(n.items, function (t, i) {
                                    (n = null !== i.image ? i.image.replace(/(\.[^.]*)$/, "_180x$1") : "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif"),
                                        null !== i.properties &&
                                            e.each(i.properties, function (e, t) {
                                                ("_" !== e.charAt(0) && t) || delete i.properties[e];
                                            });
                                    var n,
                                        a = 0;
                                    if (0 !== i.line_level_discount_allocations.length)
                                        for (var r in i.line_level_discount_allocations)
                                            (a = i.line_level_discount_allocations[r].amount), (i.line_level_discount_allocations[r].formattedAmount = theme.Currency.formatMoney(a, theme.settings.moneyFormat));
                                    (c += 2),
                                        (s = {
                                            key: i.key,
                                            url: i.url,
                                            img: n,
                                            animationRow: c,
                                            name: i.product_title,
                                            variation: i.variant_title,
                                            properties: i.properties,
                                            itemQty: i.quantity,
                                            price: theme.Currency.formatMoney(i.price, theme.settings.moneyFormat),
                                            unitPrice: theme.Currency.formatMoney(i.unit_price, theme.settings.moneyFormat),
                                            unitBase: theme.Currency.getBaseUnit(i),
                                            discountedPrice: theme.Currency.formatMoney(i.price - i.total_discount / i.quantity, theme.settings.moneyFormat),
                                            discounts: i.line_level_discount_allocations,
                                            discountsApplied: 0 !== i.line_level_discount_allocations.length,
                                            vendor: i.vendor,
                                        }),
                                        o.push(s);
                                }),
                                    (c += 2);
                                var d = 0;
                                if (0 !== n.cart_level_discount_applications.length)
                                    for (var l in n.cart_level_discount_applications)
                                        (d = n.cart_level_discount_applications[l].total_allocated_amount), (n.cart_level_discount_applications[l].formattedAmount = theme.Currency.formatMoney(d, theme.settings.moneyFormat));
                                (r = {
                                    items: o,
                                    note: n.note,
                                    lastAnimationRow: c,
                                    cartDiscounts: n.cart_level_discount_applications,
                                    cartDiscountsApplied: 0 !== n.cart_level_discount_applications.length,
                                    totalPrice: theme.Currency.formatMoney(n.total_price, theme.settings.moneyFormat),
                                }),
                                    e(i.container).append(this.template(r));
                            }
                            (this.status.loaded = !0),
                                this.loading(!1),
                                theme.settings.currenciesEnabled && theme.currencySwitcher.ajaxrefresh(),
                                e("body").trigger("updateCart" + t.namespace, n),
                                window.Shopify &&
                                    Shopify.StorefrontExpressButtons &&
                                    (Shopify.StorefrontExpressButtons.initialize(),
                                    setTimeout(
                                        function () {
                                            this.sizeFooter();
                                        }.bind(this),
                                        800
                                    )),
                                !0 === a && this.drawer.open(),
                                window.BOLD && BOLD.common && BOLD.common.eventEmitter && "function" == typeof BOLD.common.eventEmitter.emit && BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
                        },
                        initQtySelectors: function () {
                            e(i.container)
                                .find(".js-qty__wrapper")
                                .each(
                                    function (t, i) {
                                        new theme.QtySelector(e(i), { namespace: ".cart-drawer" });
                                    }.bind(this)
                                ),
                                e("body").on("qty.cart-drawer", this.updateItem.bind(this));
                        },
                        updateItem: function (e, t, i) {
                            !this.status.loading &&
                                (this.loading(!0),
                                theme.cart
                                    .changeItem(t, i)
                                    .then(
                                        function (e) {
                                            this.updateSuccess(e);
                                        }.bind(this)
                                    )
                                    .catch(
                                        function (e) {
                                            this.updateError(e);
                                        }.bind(this)
                                    )
                                    .always(
                                        function () {
                                            this.loading(!1);
                                        }.bind(this)
                                    ));
                        },
                        loading: function (t) {
                            (this.status.loading = t), t ? e(i.container).addClass("is-loading") : e(i.container).removeClass("is-loading");
                        },
                        emptyCart: function () {
                            e(i.container).empty();
                        },
                        updateSuccess: function (e) {
                            this.buildCart(e);
                        },
                        updateError: function (e) {
                            e.responseJSON && e.responseJSON.description && console.warn(e.responseJSON.description);
                        },
                        sizeFooter: function () {
                            if (e(i.drawer).hasClass("drawer--has-fixed-footer")) {
                                var t = e(i.drawer).find(i.fixedFooter).removeAttr("style"),
                                    n = e(i.drawer).find(i.fixedInnerContent).removeAttr("style"),
                                    a = t.outerHeight();
                                n.css("bottom", a), t.css("height", a);
                            }
                        },
                        updateCartNotification: function (t, n) {
                            void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (n = window.BOLD.common.cartDoctor.fix(n)),
                                n.items.length > 0 ? e(i.cartBubble).addClass("cart-link__bubble--visible") : e(i.cartBubble).removeClass("cart-link__bubble--visible");
                        },
                    })),
                    n
                );
            })()),
            (theme.AjaxProduct = (function () {
                var t = { loading: !1 };
                function i(e) {
                    (this.$form = e), (this.$addToCart = this.$form.find(".add-to-cart")), this.$form.length && this.$form.on("submit", this.addItemFromForm.bind(this));
                }
                return (
                    (i.prototype = e.extend({}, i.prototype, {
                        addItemFromForm: function (e, i) {
                            if ((e.preventDefault(), !t.loading)) {
                                if ((this.$addToCart.addClass("btn--loading"), (t.loading = !0), BOLD && BOLD.helpers && "function" == typeof BOLD.helpers.addItemFromForm))
                                    BOLD.helpers.addItemFromForm(this.$form, this.success.bind(this), this.error.bind(this), { endpoint: "/cart/add.js" }), (t.loading = !1), this.$addToCart.removeClass("btn--loading");
                                else {
                                    var n = this.$form.serialize();
                                    theme.cart
                                        .addItemFromForm(n)
                                        .then(
                                            function (e) {
                                                this.success(e);
                                            }.bind(this)
                                        )
                                        .catch(
                                            function (e) {
                                                this.error(e);
                                            }.bind(this)
                                        )
                                        .always(
                                            function () {
                                                (t.loading = !1), this.$addToCart.removeClass("btn--loading");
                                            }.bind(this)
                                        );
                                }
                            }
                        },
                        success: function (t) {
                            this.$form.find(".errors").remove(), e("body").trigger("added.ajaxProduct");
                        },
                        error: function (e) {
                            this.$form.find(".errors").remove(),
                                e.responseJSON && e.responseJSON.description && (console.warn(e.responseJSON.description), this.$form.prepend('<div class="errors text-center">' + e.responseJSON.description + "</div>"));
                        },
                    })),
                    i
                );
            })()),
            (theme.collapsibles = (function () {
                var t = { trigger: ".collapsible-trigger", module: ".collapsible-content", moduleInner: ".collapsible-content__inner" },
                    i = { hide: "hide", open: "is-open", autoHeight: "collapsible--auto-height" },
                    n = ".collapsible",
                    a = !1;
                function o(e, t, n, o) {
                    if ((e.removeClass(i.hide).prepareTransition().css("height", t).toggleClass(i.open, !n), !n && o)) {
                        var s = e;
                        window.setTimeout(function () {
                            s.css("height", "auto"), (a = !1);
                        }, 350);
                    } else a = !1;
                }
                return {
                    init: function s() {
                        e(t.trigger).each(function () {
                            var t = e(this),
                                n = t.hasClass(i.open);
                            t.attr("aria-expanded", n);
                        }),
                            e("body, .modal__inner")
                                .off(n)
                                .on("click" + n, t.trigger, function () {
                                    if (!a) {
                                        a = !0;
                                        var n = e(this),
                                            s = n.hasClass(i.open),
                                            r = e("#" + n.attr("aria-controls")),
                                            c = r.find(t.moduleInner).outerHeight(),
                                            d = n.hasClass(i.autoHeight);
                                        s &&
                                            d &&
                                            setTimeout(function () {
                                                o(r, (c = 0), s, d);
                                            }, 0),
                                            s && !d && (c = 0),
                                            n.attr("aria-expanded", !s).toggleClass(i.open, !s),
                                            o(r, c, s, d);
                                    }
                                });
                    },
                };
            })()),
            (theme.headerNav = (function () {
                var t,
                    i,
                    n,
                    a,
                    o,
                    s,
                    r = e(document.documentElement).add("body"),
                    c = e("#MainContent"),
                    d = {
                        wrapper: ".header-wrapper",
                        siteHeader: ".site-header",
                        searchBtn: ".js-search-header",
                        closeSearch: ".js-search-header-close",
                        searchContainer: ".site-header__search-container",
                        logoContainer: ".site-header__logo",
                        logo: ".site-header__logo img",
                        navigation: ".site-navigation",
                        navContainerWithLogo: ".header-item--logo",
                        navItems: ".site-nav__item",
                        navLinks: ".site-nav__link",
                        navLinksWithDropdown: ".site-nav__link--has-dropdown",
                        navDropdownLinks: ".site-nav__dropdown-link--second-level",
                    },
                    l = { hasDropdownClass: "site-nav--has-dropdown", hasSubDropdownClass: "site-nav__deep-dropdown-trigger", dropdownActive: "is-focused", overlaidBodyClass: "overlaid-header", stickyBodyClass: "sticky-header" },
                    u = {
                        namespace: ".siteNav",
                        wrapperOverlayed: !1,
                        overlayedClass: "is-light",
                        stickyEnabledClass: "header-wrapper--sticky",
                        stickyEnabled: !1,
                        stickyActive: !1,
                        stickyClass: "site-header--stuck",
                        openTransitionClass: "site-header--opening",
                        lastScroll: 0,
                    };
                function h() {
                    e(document.activeElement).trigger("blur"),
                        r.removeClass("js-drawer-open js-drawer-open--search").off(u.namespace),
                        e(d.searchContainer).removeClass("is-active"),
                        slate.a11y.removeTrapFocus({ $container: e(d.searchContainer), namespace: "header_search" }),
                        slate.a11y.unlockMobileScrolling(u.namespace),
                        c.off("click" + u.namespace),
                        r.off("keyup" + u.namespace);
                }
                function p() {
                    var t = s.outerHeight(!0);
                    e(".site-header-sticky").css("height", t), e(".grid__item--sidebar").length && e(".grid__item--sidebar").css("top", t + 10);
                }
                function f() {
                    var e = t.scrollTop();
                    if (e > 150) {
                        if (u.stickyActive) return;
                        (u.stickyActive = !0),
                            s.addClass(u.stickyClass),
                            u.wrapperOverlayed && o.removeClass(u.overlayedClass),
                            setTimeout(function () {
                                s.addClass(u.openTransitionClass);
                            }, 100);
                    } else {
                        if (!u.stickyActive) return;
                        (u.stickyActive = !1), s.removeClass(u.openTransitionClass).removeClass(u.stickyClass), u.wrapperOverlayed && o.addClass(u.overlayedClass);
                    }
                    u.lastScroll = e;
                }
                return {
                    init: function m() {
                        (t = e(window)),
                            (i = e(d.navContainerWithLogo)),
                            (n = e(d.logoContainer)),
                            (a = e(d.navigation)),
                            (o = e(d.wrapper)),
                            (s = e(d.siteHeader)),
                            (u.wrapperOverlayed = theme.settings.overlayHeader = o.hasClass(u.overlayedClass)),
                            (u.stickyEnabled = s.data("sticky")),
                            u.stickyEnabled &&
                                ((theme.config.stickyHeader = !0),
                                (u.lastScroll = 0),
                                r.addClass(l.stickyBodyClass),
                                s.wrap('<div class="site-header-sticky"></div>'),
                                p(),
                                setTimeout(function () {
                                    p();
                                }, 200),
                                t.on("resize" + u.namespace, e.debounce(50, p)),
                                t.on("scroll" + u.namespace, e.throttle(15, f))),
                            u.wrapperOverlayed && e("body").addClass(l.overlaidBodyClass),
                            (function t() {
                                var i = !1,
                                    n = !1,
                                    a = !1;
                                function o(t) {
                                    var n = t.parent();
                                    if ((n.hasClass(l.hasDropdownClass) && (n.addClass(l.dropdownActive), (i = !0)), !theme.config.isTouch && !a)) {
                                        var o = theme.config.isTouch ? "touchend" : "click";
                                        (a = !0),
                                            e("body").on(o + u.namespace, function () {
                                                r(), e("body").off(u.namespace), (a = !1);
                                            });
                                    }
                                }
                                function s(e, t) {
                                    var i = e.parent();
                                    (i.hasClass(l.hasSubDropdownClass) || t) && (i.addClass(l.dropdownActive), (n = !0));
                                }
                                function r() {
                                    c(), h();
                                }
                                function c() {
                                    e(d.navItems).removeClass(l.dropdownActive);
                                }
                                function h() {
                                    e(d.navDropdownLinks).parent().removeClass(l.dropdownActive);
                                }
                                theme.config.isTouch &&
                                    (e(d.navLinksWithDropdown).on("touchend" + u.namespace, function (t) {
                                        var i = e(this);
                                        i.parent().hasClass(l.dropdownActive) ? window.location.replace(i.attr("href")) : (t.preventDefault(), r(), o(i));
                                    }),
                                    e(d.navDropdownLinks).on("touchend" + u.namespace, function (t) {
                                        var i = e(this),
                                            n = i.parent();
                                        n.hasClass(l.hasSubDropdownClass) ? (n.hasClass(l.dropdownActive) ? window.location.replace(i.attr("href")) : (t.preventDefault(), h(), s(i))) : window.location.replace(i.attr("href"));
                                    })),
                                    e(d.navLinks).on("focusin mouseover" + u.namespace, function () {
                                        i && c(), n && h(), o(e(this));
                                    }),
                                    e(d.navLinks).on("mouseleave" + u.namespace, function () {
                                        c(), h();
                                    }),
                                    e(d.navDropdownLinks).on("focusin" + u.namespace, function () {
                                        n && h(), s(e(this), !0);
                                    });
                            })(),
                            e(d.searchBtn).on("click" + u.namespace, function (t) {
                                t.preventDefault(),
                                    e(d.searchContainer).addClass("is-active"),
                                    r.addClass("js-drawer-open js-drawer-open--search"),
                                    slate.a11y.trapFocus({ $container: e(d.searchContainer), namespace: "header_search", $elementToFocus: e(d.searchContainer).find("input") }),
                                    theme.config.bpSmall && u.stickyEnabled && u.lastScroll < 300 && window.scrollTo(0, 0),
                                    slate.a11y.lockMobileScrolling(u.namespace),
                                    c.on("click" + u.namespace, function () {
                                        return h(), !1;
                                    }),
                                    r.on("keyup" + u.namespace, function (e) {
                                        27 === e.keyCode && h();
                                    });
                            }),
                            e(d.closeSearch).on("click" + u.namespace, function () {
                                h();
                            });
                    },
                    disableOverlayHeader: function t() {
                        e(d.wrapper).removeClass(u.stickyEnabledClass).removeClass(u.overlayedClass), e("body").removeClass(l.overlaidBodyClass), (u.wrapperOverlayed = !1);
                    },
                    unload: function t() {
                        e(window).off(u.namespace), e(d.searchBtn).off(u.namespace), e(d.closeSearch).off(u.namespace), r.off(u.namespace), e(d.navLinks).off(u.namespace), e(d.navDropdownLinks).off(u.namespace);
                    },
                };
            })()),
            (theme.Slideshow = (function () {
                this.$slideshow = null;
                var t = {
                    next: "is-next",
                    init: "is-init",
                    animateOut: "animate-out",
                    wrapper: "slideshow-wrapper",
                    slideshow: "slideshow",
                    allSlides: "slick-slide",
                    currentSlide: "slick-current",
                    pauseButton: "slideshow__pause",
                    isPaused: "is-paused",
                };
                function i(i, n) {
                    (this.$slideshow = e(i)),
                        (this.$wrapper = this.$slideshow.closest("." + t.wrapper)),
                        (this.$pause = this.$wrapper.find("." + t.pauseButton)),
                        (this.settings = {
                            accessibility: !0,
                            arrows: !!n.arrows,
                            dots: !!n.dots,
                            fade: !!n.fade,
                            speed: n.speed ? n.speed : 500,
                            draggable: !0,
                            touchThreshold: 5,
                            pauseOnHover: !1,
                            autoplay: !!n.autoplay,
                            autoplaySpeed: this.$slideshow.data("speed"),
                        }),
                        this.$slideshow.off("beforeChange"),
                        this.$slideshow.off("afterSlideChange"),
                        this.$slideshow.on("init", this.init.bind(this)),
                        this.$slideshow.on("beforeChange", this.beforeSlideChange.bind(this)),
                        this.$slideshow.on("afterChange", this.afterSlideChange.bind(this)),
                        this.$slideshow.slick(this.settings),
                        this.$pause.on("click", this._togglePause.bind(this));
                }
                return (
                    (i.prototype = e.extend({}, i.prototype, {
                        init: function (e, i) {
                            (this.$slideshowList = i.$list), (this.$slickDots = i.$dots), (this.$allSlides = i.$slides), (this.slideCount = i.slideCount), this.$slideshow.addClass(t.init), this._a11y(), this._clonedLazyloading();
                        },
                        beforeSlideChange: function (e, i, n, a) {
                            i.$slider.find("." + t.currentSlide).addClass(t.animateOut);
                        },
                        afterSlideChange: function (e, i, n) {
                            i.$slider.find("." + t.allSlides).removeClass(t.animateOut);
                        },
                        destroy: function () {
                            this.$slideshow.slick("unslick");
                        },
                        _play: function () {
                            this.$slideshow.slick("slickPause"), e(t.pauseButton).addClass("is-paused");
                        },
                        _pause: function () {
                            this.$slideshow.slick("slickPlay"), e(t.pauseButton).removeClass("is-paused");
                        },
                        _togglePause: function () {
                            var i = this._getSlideshowId(this.$pause);
                            this.$pause.hasClass(t.isPaused) ? (this.$pause.removeClass(t.isPaused), e(i).slick("slickPlay")) : (this.$pause.addClass(t.isPaused), e(i).slick("slickPause"));
                        },
                        _getSlideshowId: function (e) {
                            return "#Slideshow-" + e.data("id");
                        },
                        _activeSlide: function () {
                            return this.$slideshow.find(".slick-active");
                        },
                        _currentSlide: function () {
                            return this.$slideshow.find(".slick-current");
                        },
                        _nextSlide: function (e) {
                            return this.$slideshow.find('.slideshow__slide[data-slick-index="' + e + '"]');
                        },
                        _a11y: function () {
                            var i = this.$slideshowList,
                                n = this.settings.autoplay;
                            i &&
                                (i.removeAttr("aria-live"),
                                e(t.wrapper).on(
                                    "focusin",
                                    function (a) {
                                        e(t.wrapper).has(a.target).length && (i.attr("aria-live", "polite"), n && this._pause());
                                    }.bind(this)
                                ),
                                e(t.wrapper).on(
                                    "focusout",
                                    function (a) {
                                        e(t.wrapper).has(a.target).length && (i.removeAttr("aria-live"), n && this._play());
                                    }.bind(this)
                                ));
                        },
                        _clonedLazyloading: function () {
                            var t = this.$slideshow;
                            t.find(".slick-slide").each(
                                function (i, n) {
                                    var a = e(n);
                                    if (a.hasClass("slick-cloned")) {
                                        var o = a.data("id"),
                                            s = a.find(".hero__image").removeClass("lazyloading").addClass("lazyloaded");
                                        setTimeout(function () {
                                            var e = t.find(".slideshow__slide--" + o + ":not(.slick-cloned) .hero__image").attr("style");
                                            e && s.attr("style", e);
                                        }, this.settings.autoplaySpeed / 1.5);
                                    }
                                }.bind(this)
                            );
                        },
                    })),
                    i
                );
            })()),
            (theme.announcementBar = (function () {
                var t,
                    i = 0,
                    n = !1,
                    a = { accessibility: !0, arrows: !1, dots: !1, autoplay: !0, autoplaySpeed: 5e3, touchThreshold: 20, slidesToShow: 1 };
                function o(e, t) {
                    s(e) && e.slick("unslick"), e.slick(t);
                }
                function s(e) {
                    return e.length && e.hasClass("slick-initialized");
                }
                return {
                    init: function s() {
                        if ((t = e("#AnnouncementSlider")).length) {
                            (i = t.data("block-count")), (n = t.data("compact-style"));
                            var r = e.extend({}, a, { slidesToShow: n ? 1 : i, slidesToScroll: 1 }),
                                c = e.extend({}, a, { slidesToShow: 1 });
                            theme.config.bpSmall ? o(t, c) : o(t, r),
                                e("body").on(
                                    "matchSmall",
                                    function () {
                                        o(t, c);
                                    }.bind(this)
                                ),
                                e("body").on(
                                    "matchLarge",
                                    function () {
                                        o(t, r);
                                    }.bind(this)
                                );
                        }
                    },
                    onBlockSelect: function i(n) {
                        var a = e("#AnnouncementSlide-" + n);
                        t.length && t.slick("slickPause"), a.length && t.slick("slickGoTo", a.data("index"));
                    },
                    onBlockDeselect: function e(i) {
                        t.length && s(t) && t.slick("slickPlay");
                    },
                    unload: function e() {
                        s(t) && t.slick("unslick");
                    },
                };
            })()),
            (theme.currencySwitcher = (function () {
                var t,
                    i = { dataDiv: "#CurrencyData", currencyOptions: ".currency-options__btn", pickerFlag: ".currency-picker .currency-flag", pickerLabel: ".currency-picker .currency-picker__label" },
                    n = {};
                function a() {
                    var a = e(this).data("value");
                    if (theme.settings.nativeMultiCurrency) {
                        e(this).addClass("is-active"), theme.cart.updateCurrency(a);
                        return;
                    }
                    a !== n.currency && ((n.currency = a), e(i.dataDiv).data("current-currency", a), o(a), s()), t.close();
                }
                function o(t) {
                    e(i.pickerFlag).attr("data-flag", t), e(i.pickerLabel).text(t), e(i.currencyOptions).removeClass("is-active"), e(i.currencyOptions + "[data-value=" + t + "]").addClass("is-active");
                }
                function s() {
                    if (!theme.settings.nativeMultiCurrency) {
                        var t = e(i.dataDiv).data("current-currency");
                        Currency.convertAll(Currency.currentCurrency, t);
                    }
                }
                return {
                    init: function s() {
                        var r,
                            c = e(i.dataDiv);
                        if (c.length) {
                            (t = new theme.Modals("CurrencyModal", "currency-modal", { closeOffContentClick: !1 })),
                                e(i.currencyOptions).on("click", a),
                                (n = { currency: c.data("shop-currency"), format: c.data("format"), moneyFormat: c.data("money-format"), moneyCurrencyFormat: c.data("money-currency-format") }),
                                theme.settings.nativeMultiCurrency ||
                                    ((Currency.format = n.format),
                                    (Currency.money_format[n.currency] = n.moneyFormat),
                                    (Currency.money_with_currency_format[n.currency] = n.moneyCurrencyFormat),
                                    e("span.money span.money").each(function () {
                                        e(this).parents("span.money").removeClass("money");
                                    }),
                                    e("span.money").each(function () {
                                        e(this).attr("data-currency-" + n.currency, e(this).html());
                                    }),
                                    null == (r = Currency.cookie.read())
                                        ? (Currency.currentCurrency = r = n.currency)
                                        : e(i.currencyOptions).length && 0 === e(i.currencyOptions + "[data-value=" + r + "]").length
                                        ? ((Currency.currentCurrency = n.currency), Currency.cookie.write(n.currency))
                                        : r === n.currency
                                        ? (Currency.currentCurrency = n.currency)
                                        : Currency.convertAll(n.currency, r),
                                    e(i.dataDiv).data("current-currency", r),
                                    (n.currency = r),
                                    o(r));
                        }
                    },
                    refresh: s,
                    ajaxrefresh: function t() {
                        if (!theme.settings.nativeMultiCurrency) {
                            var n = e(i.dataDiv).data("shop-currency"),
                                a = e(i.dataDiv).data("current-currency");
                            Currency.convertAll(n, a);
                        }
                    },
                };
            })()),
            (theme.initQuickShop = function (t) {
                var i = [];
                e(".quick-product__btn").each(function () {
                    var t = e(this).data("product-id");
                    if (i.indexOf(t) > -1) {
                        e('.modal--quick-shop[data-product-id="' + t + '"]').each(function (t) {
                            t > 0 && e(this).remove();
                        });
                        return;
                    }
                    new theme.Modals("QuickShopModal-" + t, "quick-modal-" + t), i.push(t);
                });
            }),
            (theme.videoModal = function () {
                var t = {
                        width: 1280,
                        height: 720,
                        playerVars: { autohide: 0, autoplay: 1, branding: 0, cc_load_policy: 0, fs: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, quality: "hd720", rel: 0, showinfo: 0, wmode: "opaque" },
                    },
                    i = { triggers: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]' };
                if (e(i.triggers).length) {
                    var n = new theme.Modals("VideoModal", "video-modal", { closeOffContentClick: !0, solid: !0 });
                    e(i.triggers).on("click", function t(i) {
                        i.preventDefault(),
                            window.loadYouTube(),
                            theme.config.youTubeReady
                                ? a(i)
                                : e("body").on("youTubeReady", function () {
                                      a(i);
                                  });
                    });
                }
                function a(i) {
                    var a,
                        o,
                        s,
                        r = ((a = e(i.currentTarget).attr("href")), (o = a.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/)), !!o && 11 == o[7].length && o[7]),
                        c = e.extend({}, t, { videoId: r });
                    c.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;
                    var d = new YT.Player("VideoHolder", c);
                    n.open(),
                        e("body").on("modalClose.VideoModal", function () {
                            setTimeout(function () {
                                d.destroy();
                            }, 500);
                        });
                }
            }),
            (theme.RecentlyViewed = (function () {
                var t = { template: "#RecentlyViewedProduct", outputContainer: "#RecentlyViewed-" },
                    i = !1;
                function n(i) {
                    var n = (this.$container = e(i)),
                        a = (this.sectionId = n.attr("data-section-id"));
                    (this.namespace = ".recently-viewed" + a), e(t.template).length && (this.checkVisibility(), e(window).on("scroll" + this.namespace, e.throttle(200, this.checkVisibility.bind(this))));
                }
                return (
                    (n.prototype = e.extend({}, n.prototype, {
                        init: function () {
                            if (!i) {
                                if (((i = !0), !e.isEmptyObject(theme.recentlyViewed.recent))) {
                                    (this.outputContainer = e(t.outputContainer + this.sectionId)), (this.handle = this.$container.attr("data-product-handle"));
                                    var n = [];
                                    for (handle in theme.recentlyViewed.recent) n.push(this.getProductInfo(handle));
                                    Promise.all(n).then(
                                        function (e) {
                                            this.setupOutput(e), this.captureProductDetails(e);
                                        }.bind(this),
                                        function (e) {
                                            console.log("Theme | recently viewed products failed to load"), console.log(e);
                                        }
                                    );
                                }
                            }
                        },
                        checkVisibility: function () {
                            theme.isElementVisible(this.$container, 600) && (this.init(), e(window).off("scroll" + this.namespace));
                        },
                        getProductInfo: function (e) {
                            return new Promise(function (t, i) {
                                theme.recentlyViewed.productInfo.hasOwnProperty(e)
                                    ? t(theme.recentlyViewed.productInfo[e])
                                    : jQuery.getJSON("/products/" + e + ".js", function (e) {
                                          t(e);
                                      });
                            });
                        },
                        setupOutput: function (i) {
                            var n = [],
                                a = {},
                                o = this.$container.attr("data-recent-count"),
                                s = 0;
                            for (key in i) {
                                var r = i[key];
                                r.handle !== this.handle &&
                                    (s++,
                                    (r.url_formatted = theme.recentlyViewed.recent[r.handle] ? theme.recentlyViewed.recent[r.handle].url : r.url),
                                    (r.image_responsive_url = theme.recentlyViewed.recent[r.handle].featuredImage),
                                    (r.image_aspect_ratio = theme.recentlyViewed.recent[r.handle].aspectRatio),
                                    (r.on_sale = r.compare_at_price > r.price),
                                    (r.sold_out = !r.available),
                                    (r.price_formatted = theme.Currency.formatMoney(r.price, theme.settings.moneyFormat)),
                                    (r.compare_at_price_formatted = theme.Currency.formatMoney(r.compare_at_price, theme.settings.moneyFormat)),
                                    (r.price_min_formatted = theme.Currency.formatMoney(r.price_min, theme.settings.moneyFormat)),
                                    (r.money_saved = theme.Currency.formatMoney(r.compare_at_price - r.price, theme.settings.moneyFormat)),
                                    n.unshift(r));
                            }
                            if (((a = { items: n.slice(0, o), grid_item_width: this.$container.attr("data-grid-item-class") }), 0 !== n.length)) {
                                var c = e(t.template).html(),
                                    d = Handlebars.compile(c);
                                this.outputContainer.append(d(a)), AOS && AOS.refreshHard();
                            }
                        },
                        captureProductDetails: function (e) {
                            for (var t = 0; t < e.length; t++) {
                                var i = e[t];
                                theme.recentlyViewed.productInfo[i.handle] = i;
                            }
                            theme.config.hasSessionStorage && sessionStorage.setItem("recent-products", JSON.stringify(theme.recentlyViewed.productInfo));
                        },
                        onUnload: function () {
                            (i = !1), e("window").off(this.namespace);
                        },
                    })),
                    n
                );
            })()),
            (theme.parallaxSections = {}),
            (theme.Parallax = (function () {
                function t(t, i) {
                    (this.$container = e(t)), (this.namespace = i.namespace), this.$container.length && (i.desktopOnly ? this.desktopInit() : this.init(this.$container, i));
                }
                return (
                    (t.prototype = e.extend({}, t.prototype, {
                        init: function (t) {
                            var i = (this.$window = e(window)),
                                n = this.$container.offset().top;
                            i.on(
                                "scroll" + this.namespace,
                                function (e) {
                                    var t = i.scrollTop();
                                    this.$container.css({ transform: "translate3d(0, " + (n - t) / 7 + "px, 0)" });
                                }.bind(this)
                            ),
                                i.on(
                                    "resize" + this.namespace,
                                    e.debounce(
                                        350,
                                        function () {
                                            if ((i.off(this.namespace), t && !theme.config.bpSmall)) {
                                                this.init(!0);
                                                return;
                                            }
                                            this.init();
                                        }.bind(this)
                                    )
                                );
                        },
                        desktopInit: function () {
                            theme.config.bpSmall || this.init(!0),
                                e("body").on(
                                    "matchSmall",
                                    function () {
                                        this.destroy();
                                    }.bind(this)
                                ),
                                e("body").on(
                                    "matchLarge",
                                    function () {
                                        this.init(!0);
                                    }.bind(this)
                                );
                        },
                        destroy: function () {
                            this.$container.removeAttr("style"), this.$window.off(this.namespace);
                        },
                    })),
                    t
                );
            })()),
            (theme.collectionTemplate = (function () {
                var t = !1,
                    i = { collectionGrid: ".collection-grid__wrapper", sidebar: "#CollectionSidebar", activeTagList: ".tag-list--active-tags", tags: ".tag-list a", filters: ".collection-filter" },
                    n = { combineTags: e(i.sidebar).data("combine-tags") },
                    a = { activeTag: "tag--active", removeTagParent: "tag--remove" };
                function o(t) {
                    var i;
                    if (((i = theme.config.bpSmall ? e("[data-scroll-to]").offset().top - 60 : e("#CollectionAjaxResult").offset().top + 1), theme.config.stickyHeader)) {
                        var n = e(".site-header").outerHeight(!0);
                        i -= n;
                    }
                    t ? e("html, body").animate({ scrollTop: i }, 300) : e("html, body").scrollTop(i);
                }
                function s() {
                    var t = e(".site-header").outerHeight(!0);
                    e(i.filters).css("top", t + 10);
                }
                function r(i) {
                    (i += "?view=ajax"),
                        e("#CollectionAjaxResult").load(
                            i + " #CollectionAjaxContent",
                            function () {
                                (t = !1), theme.reinitSection("collection-template"), theme.collectionTemplate.reinit();
                            }.bind(this)
                        );
                }
                return {
                    init: function c() {
                        e(window).on("popstate", function (e) {
                            e && r(location.href);
                        }),
                            theme.config.stickyHeader && (s(), e(window).on("resize", e.debounce(150, s))),
                            e("body").on("click", i.tags, function (s) {
                                var c = e(this);
                                if ((theme.FilterDrawer && theme.FilterDrawer.close(), !c.hasClass("no-ajax"))) {
                                    if ((s.preventDefault(), !t)) {
                                        t = !0;
                                        var c = e(s.currentTarget),
                                            d = c.parent(),
                                            l = c.attr("href");
                                        n.combineTags
                                            ? d.hasClass(a.activeTag)
                                                ? d.removeClass(a.activeTag)
                                                : (d.addClass(a.activeTag),
                                                  c.parent("li").hasClass(a.removeTagParent)
                                                      ? e(this).parent().remove()
                                                      : e(i.activeTagList).append('<li class="tag tag--remove"><a class="btn btn--small js-no-transition">' + c.text() + "</a></li>"))
                                            : (e(i.tags).parent().removeClass(a.activeTag), d.addClass(a.activeTag)),
                                            o(!0),
                                            history.pushState({}, "", l),
                                            e(i.collectionGrid).addClass("unload"),
                                            r(l);
                                    }
                                }
                            });
                    },
                    reinit: function t() {
                        (n.combineTags = e(i.sidebar).data("combine-tags")), o(!1), theme.pageTransitions(), theme.reinitProductGridItem(), e("body").trigger("resize");
                    },
                };
            })()),
            (theme.customerTemplates = (function () {
                function t() {
                    e("#RecoverPasswordForm").toggleClass("hide"), e("#CustomerLoginForm").toggleClass("hide");
                }
                return {
                    init: function () {
                        var i, n;
                        "#recover" === window.location.hash && t(),
                            e("#RecoverPassword").on("click", function (e) {
                                e.preventDefault(), t();
                            }),
                            e("#HideRecoverPasswordLink").on("click", function (e) {
                                e.preventDefault(), t();
                            }),
                            e(".reset-password-success").length && e("#ResetSuccess").removeClass("hide"),
                            (i = e("#AddressNewForm")),
                            (n = e(".js-address-form")),
                            i.length &&
                                n.length &&
                                (Shopify &&
                                    e(".js-address-country").each(function () {
                                        var t = e(this),
                                            i = t.data("country-id"),
                                            n = t.data("province-id"),
                                            a = t.data("province-container-id");
                                        new Shopify.CountryProvinceSelector(i, n, { hideElement: a });
                                    }),
                                e(".address-new-toggle").on("click", function () {
                                    i.toggleClass("hide");
                                }),
                                e(".address-edit-toggle").on("click", function () {
                                    var t = e(this).data("form-id");
                                    e("#EditAddress_" + t).toggleClass("hide");
                                }),
                                e(".address-delete").on("click", function () {
                                    var t = e(this),
                                        i = t.data("form-id");
                                    confirm(t.data("confirm-message") || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + i, { parameters: { _method: "delete" } });
                                }));
                    },
                };
            })()),
            (theme.Product = (function () {
                var t,
                    i,
                    n = { onSale: "on-sale", disabled: "disabled", isModal: "is-modal", loading: "loading", loaded: "loaded", interactable: "video-interactable", visuallyHide: "visually-invisible" },
                    a = { productVideo: ".product__video", videoParent: ".product__video-wrapper", currentSlide: ".slick-current" },
                    o = {},
                    s = [],
                    r = {
                        height: "480",
                        width: "850",
                        playerVars: { autohide: 0, autoplay: 1, branding: 0, cc_load_policy: 0, controls: 0, fs: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, quality: "hd720", rel: 0, showinfo: 0, wmode: "opaque" },
                        events: {
                            onReady: function t(i) {
                                var n = e(i.target.a),
                                    r = n.attr("id");
                                (s[r] = i.target),
                                    s[r],
                                    h(n),
                                    "muted" === o[r].style ? s[r].mute().playVideo().pauseVideo() : p(n),
                                    (n.closest(a.currentSlide).length || 1 === n.data("image-count")) && "muted" === o[r].style && (s[r].playVideo(), l(r));
                            },
                            onStateChange: function t(i) {
                                var r = e(i.target.a),
                                    c = r.attr("id"),
                                    d = s[c];
                                switch (i.data) {
                                    case -1:
                                        o[c].attemptedToPlay &&
                                            (p(r),
                                            (function e(t) {
                                                t.closest(a.videoParent).addClass(n.interactable);
                                            })(r));
                                        break;
                                    case 0:
                                        d.playVideo();
                                        break;
                                    case 1:
                                        p(r);
                                        break;
                                    case 3:
                                        o[c].attemptedToPlay = !0;
                                }
                            },
                        },
                    },
                    c = [],
                    d = { byline: !1, title: !1, portrait: !1, loop: !0 };
                function l(t) {
                    u(t), e(window).on("scroll." + t, { id: t }, e.throttle(150, u));
                }
                function u(t) {
                    var i, n, a;
                    if (((i = "string" == typeof t ? t : t.data.id), theme.isElementVisible(e("#" + i)))) {
                        if (o[i] && "unmuted" === o[i].style) return;
                        (n = i), s[n] && "function" == typeof s[n].playVideo && s[n].playVideo();
                    } else {
                        (a = i), s[a] && "function" == typeof s[a].pauseVideo && s[a].pauseVideo();
                    }
                }
                function h(e) {
                    e.closest(a.videoParent).addClass(n.loading);
                }
                function p(e) {
                    e.closest(a.videoParent).removeClass(n.loading).addClass(n.loaded);
                }
                function f(t) {
                    var i = (this.$container = e(t)),
                        n = (this.sectionId = i.attr("data-section-id"));
                    (this.inModal = i.closest(".modal").length),
                        this.$modal,
                        (this.settings = {
                            enableHistoryState: i.data("enable-history-state") || !1,
                            namespace: ".product-" + n,
                            inventory: i.data("inventory") || !1,
                            modalInit: !1,
                            lazyLoadModalContent: i.data("lazyload-content") || !1,
                            slickMainInitialized: !1,
                            slickThumbInitialized: !1,
                            hasImages: !0,
                            hasMultipleImages: !1,
                            imageSize: "620x",
                        }),
                        this.inModal && ((this.settings.enableHistoryState = !1), (this.settings.namespace = ".product-" + n + "-modal"), (this.$modal = e("#QuickShopModal-" + n))),
                        (this.selectors = {
                            variantsJson: "VariantsJson-" + n,
                            currentVariantJson: "CurrentVariantJson-" + n,
                            video: "ProductVideo-" + n,
                            photoThumbs: ".product__thumb-" + n,
                            thumbSlider: "#ProductThumbs-" + n,
                            mainSlider: "#ProductPhotos-" + n,
                            imageContainer: "[data-product-images]",
                            productImageMain: ".product-image-main--" + n,
                            priceWrapper: ".product__price-wrap-" + n,
                            price: "#ProductPrice-" + n,
                            comparePrice: "#ComparePrice-" + n,
                            savePrice: "#SavePrice-" + n,
                            priceA11y: "#PriceA11y-" + n,
                            comparePriceA11y: "#ComparePriceA11y-" + n,
                            unitWrapper: ".product__unit-price-wrapper--" + n,
                            unitPrice: ".product__unit-price--" + n,
                            unitPriceBaseUnit: ".product__unit-base--" + n,
                            sku: "#Sku-" + n,
                            inventory: "#ProductInventory-" + n,
                            addToCart: "#AddToCart-" + n,
                            addToCartText: "#AddToCartText-" + n,
                            originalSelectorId: "#ProductSelect-" + n,
                            singleOptionSelector: ".variant__input-" + n,
                            variantColorSwatch: ".variant__input--color-swatch-" + n,
                            modalFormHolder: "#ProductFormHolder-" + n,
                            formContainer: "#AddToCartForm-" + n,
                        }),
                        (this.$mainSlider = e(this.selectors.mainSlider)),
                        (this.$thumbSlider = e(this.selectors.thumbSlider)),
                        (this.$firstProductImage = this.$mainSlider.find("img").first()),
                        this.$firstProductImage.length || (this.settings.hasImages = !1),
                        this.init();
                }
                return (
                    (f.prototype = e.extend({}, f.prototype, {
                        init: function () {
                            this.inModal &&
                                (this.$container.addClass(n.isModal),
                                e("body")
                                    .off("modalOpen.QuickShopModal-" + this.sectionId)
                                    .off("modalClose.QuickShopModal-" + this.sectionId),
                                e("body").on("modalOpen.QuickShopModal-" + this.sectionId, this.openModalProduct.bind(this)),
                                e("body").on("modalClose.QuickShopModal-" + this.sectionId, this.closeModalProduct.bind(this))),
                                this.inModal || (this.stringOverrides(), this.formSetup(), this.productSetup(), this.checkIfVideos(), this.createImageCarousels(), this.addIdToRecentlyViewed());
                        },
                        formSetup: function () {
                            theme.settings.dynamicVariantsEnable && (this.$variantSelectors = e(this.selectors.formContainer).find(this.selectors.singleOptionSelector)),
                                this.initQtySelector(),
                                this.initAjaxProductForm(),
                                this.initVariants();
                        },
                        productSetup: function () {
                            this.setImageSizes(), this.initImageSwitch(), this.initImageZoom();
                        },
                        addIdToRecentlyViewed: function () {
                            var e = this.$container.attr("data-product-handle"),
                                t = this.$container.attr("data-product-url"),
                                i = this.$container.attr("data-aspect-ratio"),
                                n = this.$container.attr("data-img-url");
                            theme.recentlyViewed.recent.hasOwnProperty(e) && delete theme.recentlyViewed.recent[e],
                                (theme.recentlyViewed.recent[e] = { url: t, aspectRatio: i, featuredImage: n }),
                                Cookies.set("theme-recent", JSON.stringify(theme.recentlyViewed.recent), { path: "/", expires: 1e4 });
                        },
                        initImageZoom: function () {
                            var t = e(this.selectors.imageContainer, this.$container);
                            new theme.Photoswipe(t[0], this.sectionId);
                        },
                        stringOverrides: function () {
                            (theme.productStrings = theme.productStrings || {}), e.extend(theme.strings, theme.productStrings);
                        },
                        setImageSizes: function () {
                            if (this.settings.hasImages) {
                                var e = this.$firstProductImage[0].currentSrc;
                                e && (this.settings.imageSize = theme.Images.imageSize(e));
                            }
                        },
                        initVariants: function () {
                            if (document.getElementById(this.selectors.variantsJson)) {
                                this.variantsObject = JSON.parse(document.getElementById(this.selectors.variantsJson).innerHTML);
                                var t = {
                                    $container: this.$container,
                                    enableHistoryState: this.settings.enableHistoryState,
                                    singleOptionSelector: this.selectors.singleOptionSelector,
                                    originalSelectorId: this.selectors.originalSelectorId,
                                    variants: this.variantsObject,
                                };
                                e(this.selectors.variantColorSwatch).length &&
                                    e(this.selectors.variantColorSwatch).on(
                                        "change",
                                        function (t) {
                                            var i = e(t.currentTarget),
                                                n = i.data("color-name"),
                                                a = i.data("color-index");
                                            this.updateColorName(n, a);
                                        }.bind(this)
                                    ),
                                    (this.variants = new slate.Variants(t)),
                                    this.$container
                                        .on("variantChange" + this.settings.namespace, this.updateCartButton.bind(this))
                                        .on("variantImageChange" + this.settings.namespace, this.updateVariantImage.bind(this))
                                        .on("variantPriceChange" + this.settings.namespace, this.updatePrice.bind(this))
                                        .on("variantUnitPriceChange" + this.settings.namespace, this.updateUnitPrice.bind(this)),
                                    e(this.selectors.sku).length && this.$container.on("variantSKUChange" + this.settings.namespace, this.updateSku.bind(this)),
                                    this.settings.inventory && this.$container.on("variantChange" + this.settings.namespace, this.updateInventory.bind(this)),
                                    theme.settings.dynamicVariantsEnable &&
                                        document.getElementById(this.selectors.currentVariantJson) &&
                                        ((this.currentVariantObject = JSON.parse(document.getElementById(this.selectors.currentVariantJson).innerHTML)),
                                        this.$variantSelectors.on("change" + this.settings.namespace, this.updateVariantAvailability.bind(this)),
                                        this.setCurrentVariantAvailability(this.currentVariantObject, !0));
                            }
                        },
                        setCurrentVariantAvailability: function (t) {
                            var i = { option1: [], option2: [], option3: [] };
                            this.disableVariantGroup(e(this.selectors.formContainer).find(".variant-input-wrap"));
                            var n = this.variantsObject.filter(function (e) {
                                return t.id !== e.id && ((t.option2 === e.option2 && t.option3 === e.option3) || (t.option1 === e.option1 && t.option3 === e.option3) || (t.option1 === e.option1 && t.option2 === e.option2) || void 0);
                            });
                            for (var a in (n = Object.assign({}, { variant: t }, n)))
                                if (n.hasOwnProperty(a)) {
                                    var o = n[a],
                                        s = o.option1,
                                        r = o.option2,
                                        c = o.option3;
                                    s && -1 === i.option1.indexOf(s) && i.option1.push(s), r && -1 === i.option2.indexOf(r) && i.option2.push(r), c && -1 === i.option3.indexOf(c) && i.option3.push(c);
                                }
                            i.option1.length && this.enableVariantOptionByValue(i.option1, "option1"),
                                i.option2.length && this.enableVariantOptionByValue(i.option2, "option2"),
                                i.option3.length && this.enableVariantOptionByValue(i.option3, "option3");
                        },
                        updateVariantAvailability: function (t, i, n) {
                            if (i && n)
                                var a = i,
                                    o = n;
                            else
                                var s = e(t.currentTarget),
                                    a = s.val() ? s.val() : t.currentTarget.value,
                                    o = s.data("index");
                            var r = this.variantsObject.filter(function (e) {
                                return e[o] === a;
                            });
                            e(this.selectors.formContainer)
                                .find(".variant-input-wrap")
                                .each(
                                    function (t, i) {
                                        var n = e(i),
                                            a = n.data("index");
                                        if (a !== o) {
                                            this.disableVariantGroup(n);
                                            for (var s = 0; s < r.length; s++) this.enableVariantOption(n, r[s][a]);
                                        }
                                    }.bind(this)
                                );
                        },
                        disableVariantGroup: function (e) {
                            "dropdown" === theme.settings.dynamicVariantType ? e.find("option").prop("disabled", !0) : (e.find("input").prop("disabled", !0), e.find("label").toggleClass("disabled", !0));
                        },
                        enableVariantOptionByValue: function (t, i) {
                            for (var n = e(this.selectors.formContainer).find('.variant-input-wrap[data-index="' + i + '"]'), a = 0; a < t.length; a++) this.enableVariantOption(n, t[a]);
                        },
                        enableVariantOption: function (e, t) {
                            if (((t = t.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1")), "dropdown" === theme.settings.dynamicVariantType)) e.find('option[value="' + t + '"]').prop("disabled", !1);
                            else {
                                var i = e.find('.variant-input[data-value="' + t + '"]');
                                i.find("input").prop("disabled", !1), i.find("label").toggleClass("disabled", !1);
                            }
                        },
                        updateColorName: function (t, i) {
                            e("#VariantColorLabel-" + this.sectionId + "-" + i).text(t);
                        },
                        updateCartButton: function (t) {
                            var i = t.variant;
                            i
                                ? i.available
                                    ? (e(this.selectors.addToCart).removeClass(n.disabled).prop("disabled", !1), e(this.selectors.addToCartText).html(theme.strings.addToCart))
                                    : (e(this.selectors.addToCart).addClass(n.disabled).prop("disabled", !0), e(this.selectors.addToCartText).html(theme.strings.soldOut))
                                : (e(this.selectors.addToCart).addClass(n.disabled).prop("disabled", !0), e(this.selectors.addToCartText).html(theme.strings.unavailable));
                        },
                        updatePrice: function (t) {
                            var i = t.variant;
                            if (i) {
                                if ((e(this.selectors.price).html(theme.Currency.formatMoney(i.price, theme.settings.moneyFormat)).show(), i.compare_at_price > i.price)) {
                                    e(this.selectors.comparePrice).html(theme.Currency.formatMoney(i.compare_at_price, theme.settings.moneyFormat)),
                                        e(this.selectors.priceWrapper).removeClass("hide"),
                                        e(this.selectors.price).addClass(n.onSale),
                                        e(this.selectors.comparePriceA11y).attr("aria-hidden", "false"),
                                        e(this.selectors.priceA11y).attr("aria-hidden", "false");
                                    var a = i.compare_at_price - i.price;
                                    (a = "percent" == theme.settings.saveType ? Math.round((100 * a) / i.compare_at_price) + "%" : theme.Currency.formatMoney(a, theme.settings.moneyFormat)),
                                        e(this.selectors.savePrice).removeClass("hide").html(theme.strings.savePrice.replace("[saved_amount]", a));
                                } else
                                    e(this.selectors.priceWrapper).addClass("hide"),
                                        e(this.selectors.price).removeClass(n.onSale),
                                        e(this.selectors.comparePriceA11y).attr("aria-hidden", "true"),
                                        e(this.selectors.priceA11y).attr("aria-hidden", "true"),
                                        e(this.selectors.savePrice).addClass("hide");
                                theme.settings.currenciesEnabled && theme.currencySwitcher.ajaxrefresh();
                            }
                        },
                        updateUnitPrice: function (t) {
                            var i = t.variant;
                            i && i.unit_price
                                ? (e(this.selectors.unitPrice).html(theme.Currency.formatMoney(i.unit_price, theme.settings.moneyFormat)),
                                  e(this.selectors.unitPriceBaseUnit).text(theme.Currency.getBaseUnit(i)),
                                  e(this.selectors.unitWrapper).removeClass("hide").removeClass(n.visuallyHide))
                                : e(this.selectors.unitWrapper).addClass(n.visuallyHide);
                        },
                        updateSku: function (t) {
                            var i = t.variant,
                                n = "";
                            i && (i.sku && (n = i.sku), e(this.selectors.sku).html(n));
                        },
                        updateInventory: function (t) {
                            var i = t.variant,
                                n = !1,
                                a = 0,
                                o = e(this.selectors.inventory);
                            i && "shopify" === i.inventory_management && ((n = !0), ((a = window.inventories[this.sectionId][i.id]) <= 0 || a > theme.settings.inventoryThreshold) && (n = !1)),
                                n ? o.removeClass("hide").text(theme.strings.stockLabel.replace("[count]", a)) : o.addClass("hide");
                        },
                        updateVariantImage: function (t) {
                            var i = t.variant;
                            theme.Images.getSizedImageUrl(i.featured_image.src, this.settings.imageSize);
                            var n = e('.product__thumb[data-id="' + i.featured_image.id + '"]'),
                                a = this._slideIndex(n.closest(".product__thumb-item"));
                            void 0 !== a && this.$mainSlider.slick("slickGoTo", a);
                        },
                        initImageSwitch: function () {
                            e(this.selectors.photoThumbs).length &&
                                e(this.selectors.photoThumbs).on("click", function (e) {
                                    e.preventDefault();
                                });
                        },
                        checkIfVideos: function () {
                            var t = this.$mainSlider.find(a.productVideo);
                            if (!t.length) return !1;
                            var n = [];
                            return (
                                t.each(function () {
                                    var t = e(this).data("video-type");
                                    0 > n.indexOf(t) && n.push(t);
                                }),
                                n.indexOf("youtube") > -1 &&
                                    (theme.config.youTubeReady
                                        ? this.loadYoutubeVideos(t)
                                        : (window.loadYouTube(),
                                          e("body").on(
                                              "youTubeReady" + this.settings.namespace,
                                              function () {
                                                  this.loadYoutubeVideos(t);
                                              }.bind(this)
                                          ))),
                                n.indexOf("vimeo") > -1 &&
                                    (i
                                        ? this.loadVimeoVideos(t)
                                        : (window.loadVimeo(),
                                          e("body").on(
                                              "vimeoReady" + this.settings.namespace,
                                              function () {
                                                  this.loadVimeoVideos(t);
                                              }.bind(this)
                                          ))),
                                n.indexOf("mp4") > -1 && this.loadMp4Videos(t),
                                n
                            );
                        },
                        loadMp4Videos: function (t) {
                            t.each(function () {
                                var t = e(this);
                                if ("mp4" == t.data("video-type")) {
                                    var i = t.attr("id");
                                    t.data("video-id"), (o[this.id] = { type: "mp4", divId: i, style: t.data("video-style") });
                                }
                            });
                        },
                        loadVimeoVideos: function (t) {
                            for (var n in (t.each(function () {
                                var t = e(this);
                                if ("vimeo" == t.data("video-type")) {
                                    var i = t.attr("id"),
                                        n = t.data("video-id");
                                    o[this.id] = { type: "vimeo", divId: i, id: n, style: t.data("video-style"), width: t.data("video-width"), height: t.data("video-height") };
                                }
                            }),
                            o))
                                if ("vimeo" == o[n].type) {
                                    var a = e.extend({}, d, o[n]);
                                    c[n] = new Vimeo.Player(o[n].divId, a);
                                }
                            i = !0;
                        },
                        autoplayVimeoVideo: function (t) {
                            if (theme.config.bpSmall) {
                                var i = e("#" + t);
                                p(i);
                            } else this.requestToPlayVimeoVideo(t);
                        },
                        requestToPlayVimeoVideo: function (t) {
                            var n = e("#" + t);
                            if ((h(n), !i)) {
                                e("body").on(
                                    "vimeoReady" + this.settings.namespace,
                                    function () {
                                        this.playVimeoVideo(t);
                                    }.bind(this)
                                );
                                return;
                            }
                            this.playVimeoVideo(t);
                        },
                        playVimeoVideo: function (t) {
                            c[t].play(), "muted" === o[t].style && c[t].setVolume(0);
                            var i = e("#" + t);
                            p(i);
                        },
                        stopVimeoVideo: function (e) {
                            if (theme.config.vimeoReady) {
                                if (e) c[e].pause();
                                else for (key in c) "function" == typeof c[key].pause && c[key].pause();
                            }
                        },
                        loadYoutubeVideos: function (i) {
                            for (var n in (i.each(function () {
                                var t = e(this);
                                if ("youtube" == t.data("video-type")) {
                                    var i = t.attr("id"),
                                        n = t.data("youtube-id");
                                    o[this.id] = { type: "youtube", id: i, videoId: n, style: t.data("video-style"), width: t.data("video-width"), height: t.data("video-height"), attemptedToPlay: !1 };
                                }
                            }),
                            o))
                                if ("youtube" === o[n].type && o.hasOwnProperty(n)) {
                                    var a = e.extend({}, r, o[n]);
                                    "muted" === a.style || ((a.playerVars.controls = 1), (a.playerVars.autoplay = 0)), (s[n] = new YT.Player(n, a));
                                }
                            t = !0;
                        },
                        requestToPlayYoutubeVideo: function (t, i) {
                            if (theme.config.youTubeReady) {
                                var n = e("#" + t);
                                if ((h(n), "function" != typeof s[t].playVideo)) {
                                    var a = this;
                                    setTimeout(function () {
                                        a.playYoutubeVideo(t, i);
                                    }, 1e3);
                                    return;
                                }
                                this.playYoutubeVideo(t, i);
                            }
                        },
                        playYoutubeVideo: function (t, i) {
                            var n = e("#" + t);
                            p(n), "function" == typeof s[t].playVideo && s[t].playVideo(), i || l(t);
                        },
                        stopYoutubeVideo: function (t) {
                            if (theme.config.youTubeReady) {
                                if (t && s[t]) "function" == typeof s[t].pauseVideo && s[t].pauseVideo(), e(window).off("scroll." + t);
                                else for (key in s) "function" == typeof s[key].pauseVideo && (s[key].pauseVideo(), e(window).off("scroll." + key));
                            }
                        },
                        playMp4Video: function (t) {
                            var i = e("#" + t);
                            p(i), i[0].play();
                        },
                        stopMp4Video: function (t) {
                            if (t) e("#" + t)[0].pause();
                            else
                                for (var i in o)
                                    if ("mp4" === o[i].type) {
                                        var n = e("#" + o[i].divId)[0];
                                        "function" == typeof n.pause && n.pause();
                                    }
                        },
                        createImageCarousels: function () {
                            if (!this.$thumbSlider.length || e(this.selectors.photoThumbs).length < 2) {
                                var t = e(this.selectors.productImageMain).find(a.productVideo);
                                t.length && this.initVideo(t);
                                return;
                            }
                            this.settings.hasMultipleImages = !0;
                            var i = this.$mainSlider.find(".starting-slide"),
                                n = this._slideIndex(i);
                            this.$mainSlider.off("init"),
                                this.$mainSlider.off("beforeChange"),
                                this.$mainSlider.on("init", this.mainSlideInit.bind(this)),
                                this.$mainSlider.on("beforeChange", this.beforeSlideChange.bind(this)),
                                this.$thumbSlider.on("init", this.thumbSlideInit.bind(this)),
                                (this.mainSliderArgs = { infinite: !0, arrows: !1, dots: !0, adaptiveHeight: !0, initialSlide: n }),
                                (this.thumbSliderArgs = { initialSlide: n });
                            var o = this.setSliderArgs();
                            this.initSliders(o),
                                e("body").on(
                                    "matchSmall matchLarge",
                                    function () {
                                        var e = this.setSliderArgs();
                                        this.initSliders(e);
                                    }.bind(this)
                                ),
                                AOS && AOS.refresh();
                        },
                        initSliders: function (e) {
                            this.destroyImageCarousels(), this.$mainSlider.slick(e.main), this.$thumbSlider.slick(e.thumbs), (this.settings.slickMainInitialized = !0);
                        },
                        setSliderArgs: function () {
                            var t = {},
                                i = "beside" === this.$thumbSlider.data("position");
                            return (
                                (t.main = e.extend({}, this.mainSliderArgs, { asNavFor: this.selectors.thumbSlider, adaptiveHeight: !0, dots: !1, infinite: !1, fade: !0 })),
                                /* CO Variant B: peek next image on mobile (slide mode + centerMode) */
                                (window.matchMedia && window.matchMedia("(max-width: 768px)").matches && ((t.main.fade = !1), (t.main.adaptiveHeight = !1), (t.main.dots = !0))),
                                (t.thumbs = e.extend({}, this.thumbSliderArgs, {
                                    asNavFor: this.selectors.mainSlider,
                                    slidesToShow: 5,
                                    slidesToScroll: 1,
                                    arrows: !1,
                                    dots: !1,
                                    vertical: i,
                                    verticalSwiping: i,
                                    focusOnSelect: !0,
                                    infinite: !1,
                                    customHeightMatching: i,
                                    customSlideAdvancement: !0,
                                })),
                                t
                            );
                        },
                        destroyImageCarousels: function () {
                            this.$mainSlider && this.settings.slickMainInitialized && (this.$mainSlider.slick("unslick"), (this.settings.slickMainInitialized = !1)),
                                this.$thumbSlider && this.settings.slickThumbInitialized && (this.$thumbSlider.slick("unslick"), (this.settings.slickThumbInitialized = !1)),
                                (this.settings.slickMainInitialized = !1),
                                (this.settings.slickThumbInitialized = !1);
                        },
                        mainSlideInit: function (e, t) {
                            var i = t.$slider.find(a.currentSlide).find(a.productVideo);
                            i.length && this.initVideo(i);
                        },
                        thumbSlideInit: function (e, t) {
                            this.settings.slickThumbInitialized = !0;
                        },
                        initVideo: function (n) {
                            var a = n.data("video-type"),
                                s = n.attr("id");
                            "mp4" === a && "muted" === o[s].style && this.playMp4Video(s),
                                "youtube" === a && t && "muted" === o[s].style && this.requestToPlayYoutubeVideo(s),
                                "vimeo" === a &&
                                    (i
                                        ? this.playOrShowVimeo(s)
                                        : e("body").on(
                                              "vimeoReady" + this.settings.namespace,
                                              function () {
                                                  this.playOrShowVimeo(s);
                                              }.bind(this)
                                          )),
                                this.inModal && this.resizeSlides();
                        },
                        stopVideo: function (e, t) {
                            e || (this.stopYoutubeVideo(), this.stopVimeoVideo(), this.stopMp4Video()), "youtube" === t && this.stopYoutubeVideo(e), "mp4" === t && this.stopMp4Video(e), "vimeo" === t && this.stopVimeoVideo(e);
                        },
                        playOrShowVimeo: function (t) {
                            o[t] && "muted" === o[t].style ? this.autoplayVimeoVideo(t) : o[t] && "unmuted" === o[t].style && p(e("#" + t));
                        },
                        getVideoType: function (e) {
                            return e.data("video-type");
                        },
                        getVideoId: function (e) {
                            return e.attr("id");
                        },
                        beforeSlideChange: function (n, s, r, c) {
                            var d = s.$slider,
                                l = d.find(a.currentSlide).find(".product__video"),
                                u = d.find('.slick-slide[data-slick-index="' + c + '"]').find(".product__video");
                            if (r !== c && l.length) {
                                var h = this.getVideoType(l),
                                    f = this.getVideoId(l);
                                f && this.stopVideo(f, h);
                            }
                            if (u.length) {
                                var m = this.getVideoType(u),
                                    g = this.getVideoId(u);
                                g &&
                                    "vimeo" === m &&
                                    (i
                                        ? o[g] && "muted" === o[g].style && this.autoplayVimeoVideo(g)
                                        : e("body").on(
                                              "vimeoReady" + this.settings.namespace,
                                              function () {
                                                  o[g] && "muted" === o[g].style && this.autoplayVimeoVideo(g);
                                              }.bind(this)
                                          )),
                                    g &&
                                        "youtube" === m &&
                                        (t
                                            ? o[g] && "muted" === o[g].style && this.requestToPlayYoutubeVideo(g, !0)
                                            : e("body").on(
                                                  "youTubeReady" + this.settings.namespace,
                                                  function () {
                                                      o[g] && "muted" === o[g].style && this.requestToPlayYoutubeVideo(g, !0);
                                                  }.bind(this)
                                              )),
                                    g && o[g] && "muted" === o[g].style && "mp4" === m && this.playMp4Video(g),
                                    g && o[g] && "muted" != o[g].style && p(e("#" + g));
                            }
                        },
                        resizeSlides: function () {
                            this.settings.hasMultipleImages &&
                                (e(window).trigger("resize.slick"),
                                setTimeout(
                                    function () {
                                        this.$mainSlider && this.settings.slickMainInitialized && this.$mainSlider.slick("setPosition"), this.$thumbSlider && this.settings.slickThumbInitialized && this.$thumbSlider.slick("setPosition");
                                    }.bind(this),
                                    500
                                ));
                        },
                        _slideIndex: function (e) {
                            return e.data("index");
                        },
                        initQtySelector: function () {
                            this.$container.find(".js-qty__wrapper").each(function () {
                                new theme.QtySelector(e(this), { namespace: ".product" });
                            });
                        },
                        initAjaxProductForm: function () {
                            "drawer" === theme.settings.cartType && new theme.AjaxProduct(e(this.selectors.formContainer));
                        },
                        openModalProduct: function () {
                            if (!this.settings.modalInit) {
                                var t = e(this.selectors.modalFormHolder),
                                    i = t.data("url");
                                (i += "?view=ajax"),
                                    t.load(
                                        i + " #AddToCartForm-" + this.sectionId,
                                        function () {
                                            t.addClass("is-active"), this.formSetup(), Shopify.PaymentButton && Shopify.PaymentButton.init();
                                        }.bind(this)
                                    ),
                                    this.productSetup(),
                                    this.loadModalContent(),
                                    this.createImageCarousels(),
                                    (this.settings.modalInit = !0);
                            }
                            this.resizeSlides(), this.addIdToRecentlyViewed();
                        },
                        closeModalProduct: function () {
                            this.stopVideo(), e("body").off(this.settings.namespace), e(window).off(this.settings.namespace);
                        },
                        loadModalContent: function () {
                            var t = this.checkIfVideos();
                            t &&
                                t.indexOf("mp4") > -1 &&
                                this.$modal.find('.product__video[data-video-type="mp4"]').each(
                                    function (t, i) {
                                        var n = e(i),
                                            a = n.data("video-src"),
                                            o = document.createElement("source");
                                        o.setAttribute("src", a), n.append(o);
                                    }.bind(this)
                                );
                        },
                        onUnload: function () {
                            this.$container.off(this.settings.namespace), e("body").off(this.settings.namespace), this.destroyImageCarousels();
                        },
                    })),
                    f
                );
            })()),
            (theme.Recommendations = (function () {
                function t(t) {
                    var i = (this.$container = e(t)),
                        n = (this.sectionId = i.attr("data-section-id"));
                    (this.selectors = { recommendations: "#Recommendations-" + n, placeholder: ".product-recommendations-placeholder", sectionClass: " .product-recommendations", productResults: ".grid-product" }), this.init();
                }
                return (
                    (t.prototype = e.extend({}, t.prototype, {
                        init: function () {
                            var t = e(this.selectors.recommendations);
                            if (t.length && !1 !== t.data("enable")) {
                                var i = t.find(this.selectors.placeholder),
                                    n = t.data("product-id"),
                                    a = t.data("limit");
                                i.load(
                                    "/recommendations/products?section_id=product-recommendations&limit=" + a + "&product_id=" + n + this.selectors.sectionClass,
                                    function (i) {
                                        theme.reinitProductGridItem(t), this.updateVariantInventory(t), 0 === e(i).find(this.selectors.sectionClass).find(this.selectors.productResults).length && t.addClass("hide");
                                    }.bind(this)
                                );
                            }
                        },
                        updateVariantInventory: function (t) {
                            (window.inventories = window.inventories || {}),
                                t.find(".product__inventory-data").each(function () {
                                    var t = e(this),
                                        i = t.data("section-id");
                                    (window.inventories[i] = {}),
                                        e.each(t.data(), function (e, t) {
                                            window.inventories[i][e] = t;
                                        });
                                });
                        },
                    })),
                    t
                );
            })()),
            (theme.CollectionHeader = (function () {
                var t = { hero: ".collection-hero", parallaxContainer: ".parallax-container" };
                function i(i) {
                    var n = e(i);
                    if (((this.namespace = ".collection-header"), (this.$heroContainer = n.find(t.hero)).length)) {
                        if ((this.checkIfNeedReload(), n.data("parallax"))) {
                            var a = n.find(t.parallaxContainer),
                                o = { namespace: this.namespace };
                            theme.parallaxSections[this.namespace] = new theme.Parallax(a, o);
                        }
                    } else theme.headerNav.disableOverlayHeader();
                }
                return (
                    (i.prototype = e.extend({}, i.prototype, {
                        checkIfNeedReload: function () {
                            Shopify.designMode && theme.settings.overlayHeader && (e(".header-wrapper").hasClass("is-light") || e(".header-wrapper").hasClass("header-wrapper--sticky") || location.reload());
                        },
                        onUnload: function () {
                            theme.parallaxSections[this.namespace] && (theme.parallaxSections[this.namespace].destroy(), delete theme.parallaxSections[this.namespace]);
                        },
                    })),
                    i
                );
            })()),
            (theme.CollectionSidebar = (function () {
                var t = !1;
                function i(t) {
                    (this.$container = e(t)), this.init();
                }
                return (
                    (i.prototype = e.extend({}, i.prototype, {
                        init: function () {
                            this.onUnload(), (t = "drawer" === this.$container.data("style")), (theme.FilterDrawer = new theme.Drawers("FilterDrawer", "collection-filters", !0));
                        },
                        forceReload: function () {
                            this.init();
                        },
                        onSelect: function () {
                            if (theme.FilterDrawer) {
                                if (!t) {
                                    theme.FilterDrawer.close();
                                    return;
                                }
                                (t || theme.config.bpSmall) && theme.FilterDrawer.open();
                            }
                        },
                        onDeselect: function () {
                            theme.FilterDrawer && theme.FilterDrawer.close();
                        },
                        onUnload: function () {
                            theme.FilterDrawer && theme.FilterDrawer.close();
                        },
                    })),
                    i
                );
            })()),
            (theme.Collection = (function () {
                var t = { colorSwatchImage: ".grid-product__color-image", colorSwatch: ".color-swatch--with-image" };
                function i(t) {
                    (this.container = t), (this.sectionId = e(t).attr("data-section-id")), (this.namespace = ".collection-" + this.sectionId), this.init();
                }
                return (
                    (i.prototype = e.extend({}, i.prototype, {
                        init: function () {
                            this.$container = e(this.container);
                            var t = (this.sectionId = this.$container.attr("data-section-id"));
                            (this.namespace = ".collection-" + t), this.sortBy(), this.colorSwatchHovering(), theme.reinitSection("collection-sidebar");
                        },
                        sortBy: function () {
                            var t = e("#SortBy");
                            t.length &&
                                t.on("change" + this.namespace, function () {
                                    location.href = "?sort_by=" + e(this).val();
                                });
                        },
                        colorSwatchHovering: function () {
                            e(t.colorSwatchImage).length &&
                                this.$container.find(t.colorSwatch).on({
                                    mouseenter: function (t) {
                                        var i = ($el = e(t.currentTarget)).data("variant-id"),
                                            n = $el.data("variant-image");
                                        e(".grid-product__color-image--" + i)
                                            .css("background-image", "url(" + n + ")")
                                            .addClass("is-active");
                                    },
                                    mouseleave: function (t) {
                                        var i = ($el = e(t.currentTarget)).data("variant-id");
                                        e(".grid-product__color-image--" + i).removeClass("is-active");
                                    },
                                });
                        },
                        forceReload: function () {
                            this.onUnload(), this.init();
                        },
                        onUnload: function () {
                            e(window).off(this.namespace), this.$container.off(this.namespace), e(t.colorSwatch).off(this.namespace);
                        },
                    })),
                    i
                );
            })()),
            (theme.HeaderSection = (function () {
                var t = { drawer: "#NavDrawer", mobileSubNavToggle: ".mobile-nav__toggle-btn", hasSublist: ".mobile-nav__has-sublist" },
                    i = { navExpanded: "mobile-nav--expanded" };
                function n(t) {
                    var i = (this.$container = e(t));
                    (this.sectionId = i.attr("data-section-id")),
                        theme.reinitSection("slideshow-section"),
                        theme.currencySwitcher.init(),
                        this.initDrawers(),
                        theme.headerNav.init(),
                        theme.announcementBar.init(),
                        Shopify.designMode &&
                            setTimeout(function () {
                                e("body").trigger("resize");
                            }, 500);
                }
                return (
                    (n.prototype = e.extend({}, n.prototype, {
                        initDrawers: function () {
                            (theme.NavDrawer = new theme.Drawers("NavDrawer", "nav")), "drawer" === theme.settings.cartType && new theme.CartDrawer(), this.drawerMenuButtons();
                        },
                        drawerMenuButtons: function () {
                            e(t.drawer)
                                .find(".js-drawer-close")
                                .on("click", function (e) {
                                    e.preventDefault(), theme.NavDrawer.close();
                                });
                            var n = e(t.mobileSubNavToggle);
                            n.attr("aria-expanded", "false"),
                                n.each(function (t, i) {
                                    var n = e(i);
                                    n.attr("aria-controls", n.attr("data-aria-controls"));
                                }),
                                n.on("click", function () {
                                    var n = e(this),
                                        a = n.attr("aria-expanded"),
                                        o = !1;
                                    "true" === a ? n.attr("aria-expanded", "false") : (n.attr("aria-expanded", "true"), (o = !0)), n.closest(t.hasSublist).toggleClass(i.navExpanded, o);
                                });
                        },
                        onBlockSelect: function (e) {
                            theme.announcementBar.onBlockSelect(e.detail.blockId);
                        },
                        onDeselect: function () {
                            theme.announcementBar.onBlockDeselect();
                        },
                        onUnload: function () {
                            theme.NavDrawer.close(), theme.headerNav.unload(), theme.announcementBar.unload();
                        },
                    })),
                    n
                );
            })()),
            (theme.FeaturedContentSection = function t() {
                e(".rte").find("a:not(:has(img))").addClass("text-link");
            }),
            (theme.slideshows = {}),
            (theme.SlideshowSection = (function () {
                var t = { parallaxContainer: ".parallax-container" };
                function i(i) {
                    var n = (this.$container = e(i));
                    n.parent();
                    var a = n.attr("data-section-id");
                    (this.slideshow = "#Slideshow-" + a), (this.namespace = "." + a);
                    var o = e(i).find(".hero");
                    if ((o.length && theme.loadImageSection(o), this.init(), n.data("parallax"))) {
                        var s = { namespace: this.namespace };
                        theme.parallaxSections[this.namespace] = new theme.Parallax(n.find(t.parallaxContainer), s);
                    }
                }
                return (
                    (i.prototype = e.extend({}, i.prototype, {
                        init: function () {
                            this.onUnload();
                            var t = e(this.slideshow),
                                i = { autoplay: t.data("autoplay"), arrows: t.data("arrows"), dots: t.data("dots"), fade: !0, speed: 500 };
                            theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, i);
                        },
                        forceReload: function () {
                            this.init();
                        },
                        onUnload: function () {
                            theme.parallaxSections[this.namespace] && (theme.parallaxSections[this.namespace].destroy(), delete theme.parallaxSections[this.namespace]),
                                theme.slideshows[this.slideshow] && (theme.slideshows[this.slideshow].destroy(), delete theme.slideshows[this.slideshow]);
                        },
                        onSelect: function () {
                            e(this.slideshow).slick("slickPause");
                        },
                        onDeselect: function () {
                            e(this.slideshow).slick("slickPlay");
                        },
                        onBlockSelect: function (t) {
                            var i = e(this.slideshow),
                                n = e(".slideshow__slide--" + t.detail.blockId + ":not(.slick-cloned)").data("slick-index");
                            i.slick("slickGoTo", n).slick("slickPause");
                        },
                        onBlockDeselect: function () {
                            e(this.slideshow).slick("slickPlay");
                        },
                    })),
                    i
                );
            })()),
            (theme.VideoSection = (function () {
                var t,
                    i = [],
                    n = [],
                    a = {
                        width: 1280,
                        height: 720,
                        playerVars: { autohide: 0, branding: 0, cc_load_policy: 0, controls: 0, fs: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, quality: "hd720", rel: 0, showinfo: 0, wmode: "opaque" },
                        events: {
                            onReady: function t(i) {
                                var a = e(i.target.a),
                                    o = a.attr("id");
                                (n[o] = i.target), n[o], u(a), n[o].mute(), a.attr("tabindex", "-1"), l(o), e(window).on("scroll." + o, { id: o }, e.throttle(150, l));
                            },
                            onStateChange: function t(a) {
                                var o = e(a.target.a),
                                    s = o.attr("id"),
                                    r = n[s];
                                switch (a.data) {
                                    case -1:
                                        i[s].attemptedToPlay && (h(o), p(o));
                                        break;
                                    case 0:
                                        r.playVideo();
                                        break;
                                    case 1:
                                        h(o);
                                        break;
                                    case 3:
                                        i[s].attemptedToPlay = !0;
                                }
                            },
                        },
                    },
                    o = !1,
                    s = { byline: !1, title: !1, portrait: !1, loop: !0 },
                    r = { videoParent: ".video-parent-section" },
                    c = { loading: "loading", loaded: "loaded", interactable: "video-interactable" };
                function d(t) {
                    var i = (this.$container = e(t));
                    this.sectionId = i.attr("data-section-id");
                    var n = (this.youtubePlayerId = "YouTubeVideo-" + this.sectionId);
                    this.namespace = "." + n;
                    var a = (this.vimeoPlayerId = "Vimeo-" + this.sectionId);
                    this.$vimeoTrigger = e("#VimeoTrigger-" + this.sectionId);
                    var o,
                        s = "Mp4Video-" + this.sectionId,
                        r = e("#" + n),
                        c = e("#" + a),
                        d = e("#" + s);
                    (this.vimeoPlayer = []),
                        r.length && ((this.youtubeVideoId = r.data("video-id")), this.initYoutubeVideo()),
                        c.length && ((this.vimeoVideoId = c.data("video-id")), this.initVimeoVideo()),
                        d.length &&
                            (h(d),
                            ((o = s), document.querySelector("#" + o).play())
                                .then(function () {})
                                .catch(function (e) {
                                    p(d);
                                }));
                }
                function l(t) {
                    var i, a, o;
                    (i = "string" == typeof t ? t : !!t.data && t.data.id) &&
                        (theme.isElementVisible(e("#" + i)) ? ((a = i), n[a] && "function" == typeof n[a].playVideo && n[a].playVideo()) : ((o = i), n[o] && "function" == typeof n[o].pauseVideo && n[o].pauseVideo()));
                }
                function u(e) {
                    e.closest(r.videoParent).addClass(c.loading);
                }
                function h(e) {
                    e.closest(r.videoParent).removeClass(c.loading).addClass(c.loaded);
                }
                function p(e) {
                    e.closest(r.videoParent).addClass(c.interactable);
                }
                return (
                    (d.prototype = e.extend({}, d.prototype, {
                        initYoutubeVideo: function () {
                            (i[this.youtubePlayerId] = { id: this.youtubePlayerId, videoId: this.youtubeVideoId, type: "youtube", attemptedToPlay: !1 }),
                                t ? this.loadYoutubeVideo() : (window.loadYouTube(), e("body").on("youTubeReady" + this.namespace, this.loadYoutubeVideo.bind(this)));
                        },
                        loadYoutubeVideo: function () {
                            var o = e.extend({}, a, i[this.youtubePlayerId]);
                            (o.playerVars.controls = 0), (n[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, o)), (t = !0);
                        },
                        initVimeoVideo: function () {
                            i[this.vimeoPlayerId] = { divId: this.vimeoPlayerId, id: this.vimeoVideoId, type: "vimeo" };
                            var t = e("#" + this.vimeoPlayerId);
                            u(t),
                                this.$vimeoTrigger.on(
                                    "click",
                                    +this.namespace,
                                    function (e) {
                                        this.requestToPlayVimeoVideo(this.vimeoPlayerId);
                                    }.bind(this)
                                ),
                                o ? this.loadVimeoVideo() : (window.loadVimeo(), e("body").on("vimeoReady" + this.namespace, this.loadVimeoVideo.bind(this)));
                        },
                        loadVimeoVideo: function () {
                            var t = e.extend({}, s, i[this.vimeoPlayerId]);
                            if (((this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(i[this.vimeoPlayerId].divId, t)), (o = !0), theme.config.bpSmall)) {
                                var n = e("#" + this.vimeoPlayerId);
                                h(n);
                            } else this.requestToPlayVimeoVideo(this.vimeoPlayerId);
                        },
                        requestToPlayVimeoVideo: function (t) {
                            if (!o) {
                                e("body").on(
                                    "vimeoReady" + this.namespace,
                                    function () {
                                        this.playVimeoVideo(t);
                                    }.bind(this)
                                );
                                return;
                            }
                            this.playVimeoVideo(t);
                        },
                        playVimeoVideo: function (t) {
                            this.vimeoPlayer[t].play(), this.vimeoPlayer[t].setVolume(0);
                            var i = e("#" + t);
                            h(i);
                        },
                        onUnload: function (t) {
                            var i;
                            n["YouTubeVideo-" + t.target.id.replace("shopify-section-", "")].destroy(), e(window).off("scroll" + this.namespace), e("body").off("vimeoReady" + this.namespace);
                        },
                    })),
                    d
                );
            })()),
            (theme.BackgroundImage = (function () {
                var t = { parallaxContainer: ".parallax-container" };
                function i(i) {
                    var n = e(i),
                        a = n.attr("data-section-id");
                    if (((this.namespace = "." + a), n.length && n.data("parallax"))) {
                        var o = n.find(t.parallaxContainer),
                            s = { namespace: this.namespace, desktopOnly: !0 };
                        theme.parallaxSections[this.namespace] = new theme.Parallax(o, s);
                    }
                }
                return (
                    (i.prototype = e.extend({}, i.prototype, {
                        onUnload: function (e) {
                            theme.parallaxSections[this.namespace].destroy(), delete theme.parallaxSections[this.namespace];
                        },
                    })),
                    i
                );
            })()),
            (theme.Testimonials = (function () {
                var t = 0,
                    i = { accessibility: !0, arrows: !1, dots: !0, autoplay: !1, touchThreshold: 20, slidesToShow: 3, slidesToScroll: 3 };
                function n(n) {
                    var a = (this.$container = e(n)).attr("data-section-id");
                    this.wrapper = ".testimonials-wrapper";
                    var o = e((this.slider = "#Testimonials-" + a));
                    this.sliderActive = !1;
                    var s = e.extend({}, i, { slidesToShow: 1, slidesToScroll: 1, adaptiveHeight: !0 });
                    (t = o.data("count")) < i.slidesToShow && ((i.slidesToShow = t), (i.slidesToScroll = t)),
                        o.on("init", this.a11y.bind(this)),
                        theme.config.bpSmall ? this.init(o, s) : this.init(o, i),
                        e("body").on(
                            "matchSmall",
                            function () {
                                this.init(o, s);
                            }.bind(this)
                        ),
                        e("body").on(
                            "matchLarge",
                            function () {
                                this.init(o, i);
                            }.bind(this)
                        );
                }
                return (
                    (n.prototype = e.extend({}, n.prototype, {
                        onUnload: function () {
                            e(this.slider, this.wrapper).slick("unslick");
                        },
                        onBlockSelect: function (t) {
                            var i = e(".testimonials-slide--" + t.detail.blockId + ":not(.slick-cloned)").data("slick-index");
                            e(this.slider, this.wrapper).slick("slickGoTo", i);
                        },
                        init: function (e, t) {
                            this.sliderActive && (e.slick("unslick"), (this.sliderActive = !1)), e.slick(t), (this.sliderActive = !0), AOS && AOS.refresh();
                        },
                        a11y: function (t, i) {
                            var n = i.$list,
                                a = e(this.wrapper, this.$container);
                            n.removeAttr("aria-live"),
                                a.on("focusin", function (e) {
                                    a.has(e.target).length && n.attr("aria-live", "polite");
                                }),
                                a.on("focusout", function (e) {
                                    a.has(e.target).length && n.removeAttr("aria-live");
                                });
                        },
                    })),
                    n
                );
            })()),
            (theme.Instagram = (function () {
                var t = !1;
                function i(t) {
                    var i = (this.$container = e(t)).attr("data-section-id");
                    (this.namespace = ".instagram-" + i), (this.$target = e("#Instafeed-" + i)), this.$target.length && (this.checkVisibility(), e(window).on("scroll" + this.namespace, e.throttle(100, this.checkVisibility.bind(this))));
                }
                return (
                    (i.prototype = e.extend({}, i.prototype, {
                        checkVisibility: function () {
                            if (t) {
                                e(window).off("scroll" + this.namespace);
                                return;
                            }
                            theme.isElementVisible(this.$container) && this.init();
                        },
                        init: function () {
                            t = !0;
                            var e = this.$target.data("user-id"),
                                i = this.$target.data("client-id"),
                                n = parseInt(this.$target.data("count")),
                                a = this.$target.data("grid-item-width");
                            (this.feed = new Instafeed({
                                target: this.$target[0],
                                accessToken: i,
                                get: "user",
                                userId: e,
                                limit: n + 2,
                                template:
                                    '<div class="grid__item ' +
                                    a +
                                    '"><div class="image-wrap"><a href="{{link}}" target="_blank" style="background-image: url({{image}}); display: block; padding-bottom: 100%; background-size: cover; background-position: center;"></a></div></div>',
                                resolution: "standard_resolution",
                            })).run();
                        },
                    })),
                    i
                );
            })()),
            (theme.NewsletterPopup = (function () {
                function t(t) {
                    var i = (this.$container = e(t)),
                        n = i.attr("data-section-id");
                    if (((this.cookieName = "newsletter-" + n), i.length && "/challenge" !== window.location.pathname)) {
                        if (
                            ((this.data = { secondsBeforeShow: i.data("delay-seconds"), daysBeforeReappear: i.data("delay-days"), cookie: Cookies.get(this.cookieName), testMode: i.data("test-mode") }),
                            (this.modal = new theme.Modals("NewsletterPopup-" + n, "newsletter-popup-modal")),
                            (i.find(".errors").length || i.find(".note--success").length) && this.modal.open(),
                            i.find(".note--success").length)
                        ) {
                            this.closePopup(!0);
                            return;
                        }
                        e("body").on("modalClose." + i.attr("id"), this.closePopup.bind(this)), (!this.data.cookie || this.data.testMode) && this.initPopupDelay();
                    }
                }
                return (
                    (t.prototype = e.extend({}, t.prototype, {
                        initPopupDelay: function () {
                            setTimeout(
                                function () {
                                    this.modal.open();
                                }.bind(this),
                                1e3 * this.data.secondsBeforeShow
                            );
                        },
                        closePopup: function (e) {
                            if (this.data.testMode) {
                                Cookies.remove(this.cookieName, { path: "/" });
                                return;
                            }
                            var t = e ? 200 : this.data.daysBeforeReappear;
                            Cookies.set(this.cookieName, "opened", { path: "/", expires: t });
                        },
                        onLoad: function () {
                            this.modal.open();
                        },
                        onSelect: function () {
                            this.modal.open();
                        },
                        onDeselect: function () {
                            this.modal.close();
                        },
                        onUnload: function () {},
                    })),
                    t
                );
            })()),
            (theme.Maps = (function () {
                var t = { zoom: 14 },
                    i = null,
                    n = [],
                    a = { addressNoResults: theme.strings.addressNoResults, addressQueryLimit: theme.strings.addressQueryLimit, addressError: theme.strings.addressError, authError: theme.strings.authError },
                    o = { section: '[data-section-type="map"]', map: "[data-map]", mapOverlay: "[data-map-overlay]" },
                    s = { mapError: "map-section--load-error", errorMsg: "map-section__error errors text-center" };
                function r(t) {
                    (this.$container = e(t)),
                        (this.sectionId = this.$container.attr("data-section-id")),
                        (this.namespace = ".map-" + this.sectionId),
                        (this.$map = this.$container.find(o.map)),
                        (this.key = this.$map.data("api-key")),
                        this.key && (this.checkVisibility(), e(window).on("scroll" + this.namespace, e.throttle(50, this.checkVisibility.bind(this))));
                }
                return (
                    (window.gm_authFailure = function () {
                        Shopify.designMode && (e(o.section).addClass(s.mapError), e(o.map).remove(), e(o.mapOverlay).after('<div class="' + s.errorMsg + '">' + theme.strings.authError + "</div>"));
                    }),
                    (r.prototype = e.extend({}, r.prototype, {
                        prepMapApi: function () {
                            "loaded" === i
                                ? this.createMap()
                                : (n.push(this),
                                  "loading" !== i &&
                                      ((i = "loading"),
                                      (void 0 === window.google || void 0 === window.google.maps) &&
                                          e.getScript("https://maps.googleapis.com/maps/api/js?key=" + this.key).then(function () {
                                              (i = "loaded"),
                                                  e.each(n, function (e, t) {
                                                      t.createMap();
                                                  });
                                          })));
                        },
                        createMap: function () {
                            var i,
                                n,
                                o,
                                r,
                                c = this.$map;
                            return ((i = c),
                            (n = e.Deferred()),
                            (o = new google.maps.Geocoder()),
                            (r = i.data("address-setting")),
                            o.geocode({ address: r }, function (e, t) {
                                t !== google.maps.GeocoderStatus.OK && n.reject(t), n.resolve(e);
                            }),
                            n)
                                .then(
                                    function (i) {
                                        var n = { zoom: t.zoom, backgroundColor: "none", center: i[0].geometry.location, draggable: !1, clickableIcons: !1, scrollwheel: !1, disableDoubleClickZoom: !0, disableDefaultUI: !0 },
                                            a = (this.map = new google.maps.Map(c[0], n)),
                                            o = (this.center = a.getCenter());
                                        new google.maps.Marker({ map: a, position: a.getCenter() }),
                                            google.maps.event.addDomListener(
                                                window,
                                                "resize",
                                                e.debounce(250, function () {
                                                    google.maps.event.trigger(a, "resize"), a.setCenter(o), c.removeAttr("style");
                                                })
                                            );
                                    }.bind(this)
                                )
                                .fail(function () {
                                    var e;
                                    switch (status) {
                                        case "ZERO_RESULTS":
                                            e = a.addressNoResults;
                                            break;
                                        case "OVER_QUERY_LIMIT":
                                            e = a.addressQueryLimit;
                                            break;
                                        case "REQUEST_DENIED":
                                            e = a.authError;
                                            break;
                                        default:
                                            e = a.addressError;
                                    }
                                    Shopify.designMode &&
                                        c
                                            .parent()
                                            .addClass(s.mapError)
                                            .html('<div class="' + s.errorMsg + '">' + e + "</div>");
                                });
                        },
                        checkVisibility: function () {
                            theme.isElementVisible(this.$container, 600) && (this.prepMapApi(), e(window).off(this.namespace));
                        },
                        onUnload: function () {
                            0 !== this.$map.length && google.maps.event.clearListeners(this.map, "resize");
                        },
                    })),
                    r
                );
            })()),
            (theme.Blog = (function () {
                function t(e) {
                    this.tagFilters();
                }
                return (
                    (t.prototype = e.extend({}, t.prototype, {
                        tagFilters: function () {
                            var t = e("#BlogTagFilter");
                            t.length &&
                                t.on("change", function () {
                                    location.href = e(this).val();
                                });
                        },
                        onUnload: function () {},
                    })),
                    t
                );
            })()),
            (theme.Photoswipe = (function () {
                var t = { trigger: ".js-photoswipe__zoom", images: ".photoswipe__image", activeImage: ".slick-active .photoswipe__image" };
                function i(t, i) {
                    (this.$container = e(t)),
                        (this.sectionId = i),
                        (this.namespace = ".photoswipe-" + this.sectionId),
                        this.gallery,
                        this.$images,
                        (this.inSlideshow = !1),
                        "false" !== this.$container.attr("data-zoom") && ("true" === this.$container.attr("data-has-slideshow") && (this.inSlideshow = !0), this.init());
                }
                return (
                    (i.prototype = e.extend({}, i.prototype, {
                        init: function () {
                            var i = this.$container.find(t.trigger);
                            this.$images = this.$container.find(t.images);
                            var n = [];
                            i.on(
                                "click" + this.namespace,
                                function (i) {
                                    if (((n = this.getImageData()), this.inSlideshow)) var a = this.$container.find(t.activeImage).data("index");
                                    else var a = e(i.currentTarget).data("index");
                                    this.initGallery(n, a);
                                }.bind(this)
                            );
                        },
                        getImageData: function () {
                            var t = [];
                            return (
                                this.$images.each(function () {
                                    var i = {
                                        msrc: e(this).prop("currentSrc") || e(this).prop("src"),
                                        src: e(this).data("photoswipe-src"),
                                        w: e(this).data("photoswipe-width"),
                                        h: e(this).data("photoswipe-height"),
                                        el: e(this)[0],
                                        initialZoomLevel: 0.5,
                                    };
                                    t.push(i);
                                }),
                                t
                            );
                        },
                        initGallery: function (e, t) {
                            var i = document.querySelectorAll(".pswp")[0];
                            (this.gallery = new PhotoSwipe(i, PhotoSwipeUI_Default, e, {
                                allowPanToNext: !1,
                                captionEl: !1,
                                closeOnScroll: !1,
                                counterEl: !1,
                                history: !1,
                                index: t - 1,
                                pinchToClose: !1,
                                preloaderEl: !1,
                                scaleMode: "zoom",
                                shareEl: !1,
                                tapToToggleControls: !1,
                                getThumbBoundsFn: function (t) {
                                    var i = window.pageYOffset || document.documentElement.scrollTop,
                                        n = e[t].el.getBoundingClientRect();
                                    return { x: n.left, y: n.top + i, w: n.width };
                                },
                            })),
                                this.gallery.init(),
                                this.gallery.listen("afterChange", this.afterChange.bind(this));
                        },
                        afterChange: function () {
                            if (this.inSlideshow) {
                                var t = e("#ProductPhotos-" + this.sectionId);
                                if (t.hasClass("slick-initialized")) {
                                    var i = this.gallery.getCurrentIndex();
                                    t.slick("slickGoTo", i);
                                }
                            }
                        },
                    })),
                    i
                );
            })()),
            (theme.bp = {}),
            (theme.bp.smallUp = 769),
            (theme.bp.small = theme.bp.smallUp - 1),
            (theme.config = {
                bpSmall: !1,
                hasSessionStorage: !0,
                mediaQuerySmall: "screen and (max-width: " + theme.bp.small + "px)",
                mediaQuerySmallUp: "screen and (min-width: " + theme.bp.smallUp + "px)",
                youTubeReady: !1,
                vimeoReady: !1,
                vimeoLoading: !1,
                isTouch: !!("ontouchstart" in window || (window.DocumentTouch && window.document instanceof DocumentTouch)) || !!window.navigator.maxTouchPoints || !!window.navigator.msMaxTouchPoints,
                isIpad: /ipad/.test(window.navigator.userAgent.toLowerCase()),
                stickyHeader: !1,
                recentlyViewed: [],
            }),
            theme.config.isIpad && (document.documentElement.className += " js-ipad"),
            (theme.recentlyViewed = { recent: {}, productInfo: {} }),
            (window.onYouTubeIframeAPIReady = function () {
                (theme.config.youTubeReady = !0), e("body").trigger("youTubeReady");
            }),
            (window.loadYouTube = function () {
                if (!theme.config.youtubeReady) {
                    var e = document.createElement("script");
                    e.src = "https://www.youtube.com/iframe_api";
                    var t = document.getElementsByTagName("script")[0];
                    t.parentNode.insertBefore(e, t);
                }
            }),
            (window.loadVimeo = function () {
                if (!theme.config.vimeoLoading && !theme.config.vimeoReady) {
                    theme.config.vimeoLoading = !0;
                    var t = document.createElement("script");
                    t.src = "https://player.vimeo.com/api/player.js";
                    var i,
                        n,
                        a,
                        o = document.getElementsByTagName("script")[0];
                    o.parentNode.insertBefore(t, o),
                        ((a = e.Deferred()),
                        (i = setInterval(function () {
                            Vimeo && (clearInterval(i), clearTimeout(n), a.resolve());
                        }, 500)),
                        (n = setTimeout(function () {
                            clearInterval(i), a.reject();
                        }, 4e3)),
                        a)
                            .then(function () {
                                (theme.config.vimeoReady = !0), (theme.config.vimeoLoading = !1), e("body").trigger("vimeoReady");
                            })
                            .fail(function () {});
                }
            }),
            (theme.init = function () {
                theme.setGlobals(),
                    theme.pageTransitions(),
                    theme.collapsibles.init(),
                    slate.rte.init(),
                    AOS.init({ easing: "ease-out-quad", once: !0, offset: 60, disableMutationObserver: !0 }),
                    e(document.documentElement).on("keyup.tab", function (t) {
                        9 === t.keyCode && (e(document.documentElement).addClass("tab-outline"), e(document.documentElement).off("keyup.tab"));
                    }),
                    e(".footer__newsletter-input").on("keyup", function () {
                        e(this).addClass("footer__newsletter-input--active");
                    });
            }),
            (theme.initSecondary = function () {
                theme.initQuickShop(), theme.collectionTemplate.init(), theme.customerTemplates.init(), theme.videoModal();
            }),
            (theme.setGlobals = function () {
                (theme.config.hasSessionStorage = theme.isSessionStorageSupported()),
                    (theme.recentlyViewed.handleCookie = Cookies.get("theme-recent")),
                    theme.recentlyViewed.handleCookie && (theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.handleCookie)),
                    (theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage["recent-products"] ? JSON.parse(sessionStorage["recent-products"]) : {}),
                    theme.config.isTouch && e("body").addClass("supports-touch"),
                    enquire.register(theme.config.mediaQuerySmall, {
                        match: function () {
                            (theme.config.bpSmall = !0), e("body").trigger("matchSmall");
                        },
                        unmatch: function () {
                            (theme.config.bpSmall = !1), e("body").trigger("unmatchSmall");
                        },
                    }),
                    enquire.register(theme.config.mediaQuerySmallUp, {
                        match: function () {
                            e("body").trigger("matchLarge");
                        },
                        unmatch: function () {
                            e("body").trigger("unmatchLarge");
                        },
                    });
            }),
            (theme.loadImageSection = function (e) {
                function t() {
                    e.removeClass("loading loading--delayed").addClass("loaded");
                }
                function i() {
                    return e.find(".lazyloaded").length;
                }
                if (e.find("svg").length || i() > 0) {
                    t();
                    return;
                }
                var n = setInterval(function () {
                    i() > 0 && (clearInterval(n), t());
                }, 80);
            }),
            (theme.isSessionStorageSupported = function () {
                if (window.self !== window.top) return !1;
                var e = "test",
                    t = window.sessionStorage;
                try {
                    return t.setItem(e, "1"), t.removeItem(e), !0;
                } catch (i) {
                    return !1;
                }
            }),
            (theme.isElementVisible = function (e, t) {
                var i = e[0].getBoundingClientRect(),
                    n = window.innerHeight || document.documentElement.clientHeight;
                return (t = t || 0), i.bottom >= 0 && i.right >= 0 && i.top <= n + t && i.left <= (window.innerWidth || document.documentElement.clientWidth);
            }),
            (theme.pageTransitions = function () {
                if (!0 == e("body").data("transitions")) {
                    var t = ".page-transition";
                    navigator.userAgent.match(/Version\/[\d\.]+.*Safari/) &&
                        e("a")
                            .off(t)
                            .on("click" + t, function () {
                                window.setTimeout(function () {
                                    e("body").removeClass("unloading");
                                }, 1200);
                            }),
                        e('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]').each(function () {
                            e(this).addClass("js-no-transition");
                        }),
                        e("a:not(.js-no-transition)")
                            .off(t)
                            .on("click" + t, function (t) {
                                if (t.metaKey) return !0;
                                t.preventDefault(), e("body").addClass("unloading");
                                var i = e(this).attr("href");
                                window.setTimeout(function () {
                                    location.href = i;
                                }, 50);
                            }),
                        e("a.mobile-nav__link")
                            .off(t)
                            .on("click" + t, function () {
                                theme.NavDrawer.close();
                            });
                }
            }),
            (theme.reinitSection = function (e) {
                for (var t = 0; t < sections.instances.length; t++) {
                    var i = sections.instances[t];
                    i.type === e && "function" == typeof i.forceReload && i.forceReload();
                }
            }),
            (theme.reinitProductGridItem = function (e) {
                AOS && AOS.refreshHard(),
                    theme.settings.currenciesEnabled && theme.currencySwitcher.ajaxrefresh(),
                    theme.initQuickShop(!0),
                    window.SPR && (SPR.initDomEls(), SPR.loadBadges()),
                    sections.register("product-template", theme.Product, e),
                    theme.collapsibles.init();
            }),
            (window.onpageshow = function (t) {
                t.persisted && e("body").removeClass("unloading");
            }),
            e(document).ready(function () {
                theme.init(),
                    (window.sections = new theme.Sections()),
                    sections.register("header-section", theme.HeaderSection),
                    sections.register("slideshow-section", theme.SlideshowSection),
                    sections.register("video-section", theme.VideoSection),
                    sections.register("background-image", theme.BackgroundImage),
                    sections.register("recently-viewed", theme.RecentlyViewed),
                    sections.register("product", theme.Product),
                    sections.register("product-recommendations", theme.Recommendations),
                    sections.register("product-template", theme.Product),
                    sections.register("collection-header", theme.CollectionHeader),
                    sections.register("collection-sidebar", theme.CollectionSidebar),
                    sections.register("collection-template", theme.Collection),
                    sections.register("featured-content-section", theme.FeaturedContentSection),
                    sections.register("testimonials", theme.Testimonials),
                    sections.register("instagram", theme.Instagram),
                    sections.register("newsletter-popup", theme.NewsletterPopup),
                    sections.register("map", theme.Maps),
                    sections.register("blog", theme.Blog),
                    sections.register("photoswipe", theme.Photoswipe),
                    theme.initSecondary();
            });
    })(theme.jQuery);
